//集中项目所有接口的apis.js

import axios from "./$http";
import base from "./base";

const apis = {
  display(paramsData) {
    return axios.get(`/sale/display`, { params: paramsData });
  },
  parkList(paramsData) {
    return axios.get(`/sale/park/list`, { params: paramsData });
  },
  updatePwd(paramsData) {
    return axios.post(`/sale/my/staff/updatePwd`, paramsData);
  },
  clearDevice(paramsData) {
    return axios.post(`/sale/my/staff/clear`, paramsData);
  },
  getUserInfo(paramsData) {
    return axios.get(`/my/staff/get`, { params: paramsData });
  },
  login(paramsData) {
    return axios.post(`/sale/login`, paramsData);
  },
  projectList(paramsData) {
    return axios.post(`/sale/project/manage/projectList`, paramsData);
  },
  getProjectDetail(paramsData) {
    return axios.get(`/sale/project/manage/projectDetail`, {
      params: paramsData
    });
  },
  updateProject(paramsData) {
    return axios.post(`/sale/project/manage/updateProject`, paramsData);
  },
  getUpdateRecord(paramsData) {
    return axios.get(`/sale/project/manage/updateRecord`, {
      params: paramsData
    });
  },
  //获取业主列表
  proprietorlist(paramsData) {
    return axios.post(`/sale/customer/list`, paramsData);
  },
  //工作台获取项目信息
  workbenchgetProjectList(paramsData) {
    return axios.post(`/sale/workbench/getProjectList`, paramsData);
  },
  //获取拓展人员
  selectAllDevelop(paramsData) {
    return axios.get(`/sale/workbench/selectAllDevelop`, paramsData);
  },
  //获取工作台面板信息
  workbenchstatisticalData(paramsData) {
    return axios.get(`/sale/workbench/statisticalData`, { params: paramsData });
  },
  //获取经理团队
  getManagerTeam(paramsData) {
    return axios.get(`/sale/manager/team`, { params: paramsData });
  },
  //获取所有经理团队
  getAllManager(paramsData) {
    return axios.get(`/sale/manager/allManager`, { params: paramsData });
  },
  //获取部团队下的经理
  getDeptManagerStaff(paramsData) {
    return axios.get(`/sale/manager/deptManagerStaff`, { params: paramsData });
  },
  //获取调拨记录
  getAllocationLog(paramsData) {
    return axios.get(`/sale/manager/getAllocationLog`, { params: paramsData });
  },
  //政委修改销售排序
  updateSort(paramsData) {
    return axios.post(`/sale/project/manage/updateSort`, paramsData);
  },
  //获取所有销售政委
  getAllMs(paramsData) {
    return axios.get(`/sale/manager/allMsData`, { params: paramsData });
  },
  //获取项目库存
  getReserveDetail(paramsData) {
    return axios.get(`/sale/project/manage/reserveDetail`, {
      params: paramsData
    });
  },
  //获取财务仓行政仓库存
  getReserveList(paramsData) {
    return axios.get(`/sale/inventory/reserveList`, { params: paramsData });
  },
  //获取业主详情
  getCustomerDetail(paramsData) {
    return axios.get(`/sale/customer/detail`, { params: paramsData });
  },
  //获取车位列表
  parkingplaceList(paramsData) {
    return axios.post(`/sale/park/list`, paramsData);
  },
  //获取车位详情
  parkingplaceview(paramsData) {
    return axios.get(`/sale/park/detail`, { params: paramsData });
  },
  //获取车位类型
  parkingtype(paramsData) {
    return axios.get(`/sale/park/getParkType`, { params: paramsData });
  },
  //获取车位标签
  parkinglable(paramsData) {
    return axios.get(`/sale/park/all`, { params: paramsData });
  },
  //获取新版车位标签
  getParkinglable(paramsData) {
    return axios.get(`/sale/park/tagList`, { params: paramsData });
  },
  //获取车位列表
  addlable(paramsData) {
    return axios.post(`/sale/park/add`, paramsData);
  },
  //获取项目流程模板
  getSaleProcessContent(paramsData) {
    return axios.get(`/sale/project/manage/saleProcessContent`, {
      params: paramsData
    });
  },
  //获取项目流程详情
  getSaleProcessDetail(paramsData) {
    return axios.get(`/sale/project/manage/saleProcessDetail`, {
      params: paramsData
    });
  },
  //项目流程保存
  saveSaleProcess(paramsData) {
    return axios.post(`/sale/project/manage/saleProcess`, paramsData);
  },
  //项目流程进度保存
  saleProcessSave(paramsData) {
    return axios.post(`/sale/project/manage/saleProcessSave`, paramsData);
  },
  //流程审核列表
  processCheckList(paramsData) {
    return axios.post(`/sale/project/process/checkList`, paramsData);
  },
  //流程新增
  processAdd(paramsData) {
    return axios.post(`/sale/project/process/add`, paramsData);
  },
  //流程详情
  processDetail(paramsData) {
    return axios.get(`/sale/project/process/detail`, { params: paramsData });
  },
  //流程审核
  processDetailCheck(paramsData) {
    return axios.post(`/sale/project/process/check`, paramsData);
  },
  //项目流程-遗留问题-保存
  saveRemainProblem(paramsData) {
    return axios.post(`/sale/project/remainProblem/save`, paramsData);
  },
  //项目流程-遗留问题-待办处理
  handleRemainProblem(paramsData) {
    return axios.post(`/sale/project/remainProblem/handle`, paramsData);
  },
  //获取项目流程-遗留问题列表
  getRemainProblemList(paramsData) {
    return axios.get(`/sale/project/remainProblem/list`, {
      params: paramsData
    });
  },
  //获取待办内遗留问题详情
  lastFollowDetail(paramsData) {
    return axios.get(`/sale/project/remainProblem/lastFollowDetail`, {
      params: paramsData
    });
  },
  //绑定标签
  bindLable(paramsData) {
    return axios.post(`/sale/park/bind`, paramsData);
  },
  //批量绑定标签
  batchBindLable(paramsData) {
    return axios.post(`/sale/park/batchBind`, paramsData);
  },
  //获取标签记录
  getTagRecord(paramsData) {
    return axios.get(`/sale/customer/tag/tagRecord`, { params: paramsData });
  },
  //车位修改提交
  parkingUpdate(paramsData) {
    return axios.post(`/sale/park/update`, paramsData);
  },
  //获取银行卡
  getBank(paramsData) {
    return axios.get(`/sale/park/getBank`, { params: paramsData });
  },
  //查询日志列表
  dailyRecordList(paramsData) {
    return axios.post(`/sale/my/daily/list`, paramsData);
  },
  //查询我的日志列表
  myDailyRecordList(paramsData) {
    return axios.post(`/sale/my/daily/myList`, paramsData);
  },
  //查询点评人
  ReplyList(paramsData) {
    return axios.post(`/sale/my/staff/searchReply`, paramsData);
  },
  //添加日志
  adddaily(paramsData) {
    return axios.post(`/sale/my/daily/add`, paramsData);
  },
  //获取日志详情
  getdaily(paramsData) {
    return axios.get(`/sale/my/daily/get`, { params: paramsData });
  },
  //编辑日志
  editdaily(paramsData) {
    return axios.post(`/sale/my/daily/update`, paramsData);
  },
  //获取日志分类列表
  getDailyLogType(paramsData) {
    return axios.get(`/sale/my/daily/getDailyLogType`, { params: paramsData });
  },
  //获取职位
  getroleInfo(paramsData) {
    return axios.get(`/sale/my/daily/roleInfo`, { params: paramsData });
  },
  //获取分配任务以及名单
  getTaskList(paramsData) {
    return axios.get(`/sale/project/manage/taskList`, { params: paramsData });
  },
  //保存分配任务名单
  saveManagerTask(paramsData) {
    return axios.post(`/sale/project/manage/managerTask`, paramsData);
  },
  //政委分配员工任务列表
  staffTaskXMList(paramsData) {
    return axios.get(`/sale/project/manage/staffTask`, { params: paramsData });
  },
  //政委分配员工方式
  disTypeXM(paramsData) {
    return axios.post(`/sale/project/manage/disType`, paramsData);
  },
  //政委分配员工任务详情
  getTaskDetail(paramsData) {
    return axios.get(`/sale/project/manage/taskDetail`, { params: paramsData });
  },
  //政委分配员工保存
  saveTaskXM(paramsData) {
    return axios.post(`/sale/project/manage/saveTask`, paramsData);
  },
  //项目库存接收列表
  addReceive(paramsData) {
    return axios.post(`/sale/project/manage/receive`, paramsData);
  },
  //销售总监分配佣金任务
  addTask(paramsData) {
    return axios.post(`/sale/project/manage/task`, paramsData);
  },
  //获取销售总监分配佣金任务接口
  getTask(paramsData) {
    return axios.get(`/sale/project/manage/getTask`, { params: paramsData });
  },
  //项目库存遗失报备
  addLost(paramsData) {
    return axios.post(`/sale/project/manage/lost`, paramsData);
  },
  //移交库存
  reserveOut(paramsData) {
    return axios.post(`/sale/project/manage/reserveOut`, paramsData);
  },
  //跟进列表
  getFollowList(paramsData) {
    return axios.post(`/sale/customer/follow/list`, paramsData);
  },
  //获取跟进详情
  getFollowDetail(paramsData) {
    return axios.get(`/sale/customer/follow/detail`, { params: paramsData });
  },
  //更新业主状态
  updataCustomer(paramsData) {
    return axios.post(`/sale/customer/update`, paramsData);
  },
  //获取业主标签
  getCustomerTagList(paramsData) {
    return axios.get(`/sale/customer/tagList`, { params: paramsData });
  },
  //获取业主标签(新版)
  getNewCustomerTagList(paramsData) {
    return axios.get(`/sale/customer/tag/tagList`, { params: paramsData });
  },
  //添加业主标签
  addCustomerTag(paramsData) {
    return axios.get(`/sale/customer/tagAdd`, { params: paramsData });
  },
  //绑定业主标签
  bindCustomerTag(paramsData) {
    return axios.post(`/sale/customer/bind`, paramsData);
  },
  //绑定业主标签(新版)
  bindNewCustomerTag(paramsData) {
    return axios.post(`/sale/customer/tag/bind`, paramsData);
  },
  //检车标签
  checkTag(paramsData) {
    return axios.post(`/sale/customer/tag/checkTag`, paramsData);
  },
  //检车标签结果
  getCheckTagResult(paramsData) {
    return axios.get(`/sale/customer/tag/getCheckTagResult`, {
      params: paramsData
    });
  },
  //销售待跟进列表
  followListXS(paramsData) {
    return axios.post(`/sale/workbench/followList`, paramsData);
  },
  //签约待审核列表查询
  signListXS(paramsData) {
    return axios.post(`/sale/workbench/signList`, paramsData);
  },
  //获取待接收列表
  acceptedReserve(paramsData) {
    return axios.get(`/sale/workbench/acceptedReserve`, { params: paramsData });
  },
  //新增业主跟进
  addFollow(paramsData) {
    return axios.post(`/sale/customer/follow/follow`, paramsData);
  },
  //测试
  //新增送礼
  sendGift(paramsData) {
    return axios.post(`/sale/customer/sendGift`, paramsData);
  },
  //送礼记录
  giftRecord(paramsData) {
    return axios.get(`/sale/customer/giftRecord`, { params: paramsData });
  },
  //礼品库存查询
  getGiftList(paramsData) {
    return axios.get(`/sale/customer/gift`, { params: paramsData });
  },
  //礼品库存查询
  getServiceList(paramsData) {
    return axios.get(`/sale/buy/serviceList`, { params: paramsData });
  },
  //添加服务费
  addService(paramsData) {
    return axios.post(`/sale/buy/serviceAdd`, paramsData);
  },
  //服务费详情
  getServiceDetail(paramsData) {
    return axios.get(`/sale/buy/serviceDetail`, { params: paramsData });
  },
  //退款
  undealAdd(paramsData) {
    return axios.post(`/sale/buy/undealAdd`, paramsData);
  },
  //签约详情
  getSignDetail(paramsData) {
    return axios.get(`/sale/buy/signDetail`, { params: paramsData });
  },
  // //服务费详情
  // getServiceDetail(paramsData) {
  //   return axios.get(`/sale/buy/serviceDetail`, { params: paramsData });
  // },
  //服务费作废
  toVoidServiceFee(paramsData) {
    return axios.post(`/sale/buy/serviceDel`, paramsData);
  },
  //业主尾款列表
  getFinalList(paramsData) {
    return axios.get(`/sale/buy/finalList`, { params: paramsData });
  },
  //新增业主购买车位尾款
  finalAdd(paramsData) {
    return axios.post(`/sale/buy/finalAdd`, paramsData);
  },
  //尾款详情
  finalDetail(paramsData) {
    return axios.get(`/sale/buy/finalDetail`, { params: paramsData });
  },
  //业主签约列表
  getSignList(paramsData) {
    return axios.get(`/sale/buy/signList`, { params: paramsData });
  },
  //获取通话记录
  getCallList(paramsData) {
    return axios.get(`/sale/customer/call`, { params: paramsData });
  },
  //查询业主签约审核记录详情
  getSignCheckRecord(paramsData) {
    return axios.get(`/sale/buy/signCheckRecord`, { params: paramsData });
  },
  //客户跟进内容
  getFollowContent(paramsData) {
    return axios.get(`/sale/workbench/getFollowContent`, {
      params: paramsData
    });
  },
  //销售总监待分配
  getWorkProjectList(paramsData) {
    return axios.post(`/sale/workbench/projectList`, paramsData);
  },
  getProjectOutOfOwen(paramsData) {
    return axios.post(`/sale/project/manage/projectOutOfOwen`, paramsData);
  },
  //新增业主签约审核
  signCheck(paramsData) {
    return axios.post(`/sale/buy/signCheck`, paramsData);
  },
  //新增业主签约
  signAdd(paramsData) {
    return axios.post(`/sale/buy/signAdd`, paramsData);
  },
  //号外号在线呼叫
  tHwhCall(paramsData) {
    return axios.post(base.phoneUrl + `/call/call`, paramsData);
  },
  //经理团队
  getTeam(paramsData) {
    return axios.get(`/sale/manager/team`, { params: paramsData });
  },
  //经理团队替换
  teamReplace(paramsData) {
    return axios.post(`/sale/manager/replace`, paramsData);
  },
  //获取全部区域
  getAllRegion(paramsData) {
    return axios.get(`/sale/my/static/allRegion`, { params: paramsData });
  },
  //条件查询所有车位列表
  searchAllList(paramsData) {
    return axios.post(`/sale/park/AllList`, paramsData);
  },
  //文件上传
  fileUpload(paramsData) {
    // return axios.post(`http://192.168.1.154:9803/upload/upload/file`, paramsData);
    return axios.post(base.uploadUrl + `/upload/upload/file`, paramsData);
  },
  //获取业主意向车位列表信息
  getWantParkList(paramsData) {
    return axios.get(`/sale/buy/wantParkList`, { params: paramsData });
  },
  //获取车位费用详情
  selectServiceFee(paramsData) {
    return axios.get(`/sale/buy/selectServiceFee`, { params: paramsData });
  },
  //更新用户头像
  updateUserInfo(paramsData) {
    return axios.post(`/sale/my/staff/update`, paramsData);
  },
  //车位落位列表
  getParkWant(paramsData) {
    return axios.get(`/sale/park/parkWant`, { params: paramsData });
  },
  //获取项目团队具体信息
  getProjectTeamInfo(paramsData) {
    return axios.get(`/sale/manager/projectTeamInfo`, { params: paramsData });
  },
  //获取项目团队具体信息
  getProjectTeamInfoEx(paramsData) {
    return axios.get(`/sale/customer/saleStaff`, { params: paramsData });
  },
  //条件查询所有业主跟进列表
  getFollowUpAllList(paramsData) {
    return axios.post(`/sale/customer/follow/AllList`, paramsData);
  },
  //获取项目团队
  getProjectTeam(paramsData) {
    return axios.get(`/sale/manager/projectTeam`, { params: paramsData });
  },
  //判断当前项目是否属于
  owenProject(paramsData) {
    return axios.get(`/sale/workbench/owenProject`, { params: paramsData });
  },
  //获取合作银行
  getCooperationBank(paramsData) {
    return axios.get(`/sale/buy/cooperationBank`, { params: paramsData });
  },
  //项目送礼新增
  managerSendGift(paramsData) {
    return axios.post(`/sale/project/manage/sendGift`, paramsData);
  },
  //项目送礼记录
  getSendGiftLog(paramsData) {
    return axios.get(`/sale/project/manage/sendGiftLog`, {
      params: paramsData
    });
  },
  //提交意见与反馈
  addFeedBack(paramsData) {
    return axios.post(`/sale/feedback/add`, paramsData);
  },
  //我的意见与反馈列表
  feedBackList(paramsData) {
    return axios.post(`/sale/feedback/list`, paramsData);
  },
  //意见与反馈详情
  feedBackDetail(paramsData) {
    return axios.get(`/sale/feedback/detail`, { params: paramsData });
  },
  //统计-获取项目信息
  statisticsProjectData(paramsData) {
    return axios.post(`/sale/workbench/selectProjectData`, paramsData);
  },
  //统计-获取数据统计车位信息
  statisticsParkData(paramsData) {
    return axios.post(`/sale/workbench/selectParkData`, paramsData);
  },
  //统计-获取数据统计头部信息
  statisticsHeadData(paramsData) {
    return axios.post(`/sale/workbench/selectHeadData`, paramsData);
  },
  //统计-获取数据客户信息
  statisticsCustomerData(paramsData) {
    return axios.post(`/sale/workbench/selectCustomerData`, paramsData);
  },
  //统计-长租用户相关
  statisticsSelectRentData(paramsData) {
    return axios.post(`/sale/workbench/selectRentData`, paramsData);
  },
  //统计-获取业绩数据信息
  statisticsAchievementData(paramsData) {
    return axios.post(`/sale/workbench/selectAchievementData`, paramsData);
  },
  //统计-获取跟进数据信息
  statisticsSelectFollowData(paramsData) {
    return axios.post(`/sale/workbench/selectFollowData`, paramsData);
  },
  //统计-获取落位数据信息
  statisticsSelectSeatData(paramsData) {
    return axios.post(`/sale/workbench/selectSeatData`, paramsData);
  },
  //统计-获取礼品数据信息
  statisticsSelectGiftData(paramsData) {
    return axios.post(`/sale/workbench/selectGiftData`, paramsData);
  },
  //服务费修改记录
  serviceChangeLog(paramsData) {
    return axios.get(`/sale/buy/updateRecord`, { params: paramsData });
  },
  //新增标签
  addTag(paramsData) {
    return axios.post(`/sale/project/tag/add`, paramsData);
  },
  //查询所有标签
  getAllTag(paramsData) {
    return axios.get(`/sale/project/tag/all`, { params: paramsData });
  },
  //绑定标签
  bindTag(paramsData) {
    return axios.post(`/sale/project/tag/bind`, paramsData);
  },
  //日常消耗
  useUp(paramsData) {
    return axios.post(`/sale/project/manage/reserveConsume`, paramsData);
  },
  //业主通话记录查询
  getCallListForStaff(paramsData) {
    return axios.post(`/sale/workbench/callList`, paramsData);
  },
  //获取通话详情
  getCallDetail(paramsData){   // /sale/call/callDetail
    return axios.get(`/sale/call/callDetail`, { params: paramsData });
  },
  //查询员工详情
  getStaffInfo(paramsData) {
    return axios.get(`/sale/my/staff/get`, { params: paramsData });
  },
  //号外号绑定
  registerPhone(phone) {
    return axios.post(`/sale/tHwh/register/${phone}`);
  },
  //是否写日志
  isWriteDailyRecord(paramsData) {
    return axios.get(`/sale/my/daily/isWrite`, { params: paramsData });
  },
  //工作台-查询签约列表
  saleedList(paramsData) {
    return axios.post(`/sale/workbench/saleList`, paramsData);
  },
  //工作台-查询签约列表
  serviceedList(paramsData) {
    return axios.post(`/sale/workbench/parkList`, paramsData);
  },
  //查询送礼业主列表
  selectGiftCustomer(paramsData) {
    return axios.post(`/sale/workbench/selectGiftCustomer`, paramsData);
  },
  //新增批量业主送礼
  batchSendGift(paramsData) {
    return axios.post("/sale/customer/batchSendGift", paramsData);
  },
  //查询签约送礼业主列表
  selectSignGiftCustomer(paramsData) {
    return axios.post("/sale/workbench/selectSignGiftCustomer", paramsData);
  },
  //消息列表
  msgList(paramsData) {
    return axios.post(`/sale/message/list`, paramsData);
  },
  //消息面板统计
  msgUnread(paramsData) {
    return axios.get(`/sale/my/static/unread`, { params: paramsData });
  },
  //消息变更为已读
  msgRead(paramsData) {
    return axios.post(`/sale/message/read`, paramsData);
  },
  //全部消息变更为已读
  allRead(paramsData) {
    return axios.post(`/sale/message/allRead`, paramsData);
  },
  //公告列表
  noticeList(paramsData) {
    return axios.post(`/sale/announcement/list`, paramsData);
  },
  //公告详情
  noticeDetail(paramsData) {
    return axios.post(`/sale/announcement/detail`, paramsData);
  },
  //公告变更为已读
  noticeRead(paramsData) {
    return axios.post(`/sale/announcement/read`, paramsData);
  },
  //首页是否弹出公告
  noticeIsPopup(paramsData) {
    return axios.post(`/sale/announcement/popup`, paramsData);
  },
  //首页是否弹出跟进
  remindFollow(paramsData) {
    return axios.get(`/sale/customer/follow/remind`, { params: paramsData });
  },
  //首页是否弹出抵押
  pendingMortgageInfo(paramsData) {
    return axios.get(`/sale/ContractMortgage/pendingMortgageInfo`, {
      params: paramsData
    });
  },
  //获取在团队呆过的销售信息
  projectAllTeamInfo(paramsData) {
    return axios.get(`/sale/manager/projectAllTeamInfo`, {
      params: paramsData
    });
  },
  //意见反馈变更为已读
  feedbackRead(paramsData) {
    return axios.get(`/sale/feedback/read`, { params: paramsData });
  },
  //提交建议反馈
  submitFeedback(paramsData) {
    return axios.post(`/sale/feedback/resolve`, paramsData);
  },
  //待撤场详情
  getWithdrawalDetail(paramsData) {
    return axios.get(`/sale/workbench/getWithdrawalDetail`, {
      params: paramsData
    });
  },
  //待撤场操作
  withdrawalAction(paramsData) {
    return axios.post(`/sale/workbench/withdrawalAction`, paramsData);
  },
  //消息统计
  commonData(paramsData) {
    return axios.get(`/sale/my/static/commonData`, { params: paramsData });
  },
  //销售经理激活任务
  managerActiveTask(paramsData) {
    return axios.post(`/sale/project/manage/managerActiveTask`, paramsData);
  },
  //销售当前已交服务费数量
  currentDealQty(paramsData) {
    return axios.get(`/sale/buy/currentDealQty`, { params: paramsData });
  },
  //服务费审核
  serviceCheck(paramsData) {
    return axios.post("/sale/buy/serviceCheck", paramsData);
  },
  //新增业主补缴车位服务费
  serviceFeeAdd(paramsData) {
    return axios.post("/sale/buy/serviceFeeAdd", paramsData);
  },
  //获取打分表
  scoringDetail(paramsData) {
    return axios.get("/sale/scoring/web/detail", { params: paramsData });
  },
  //获取打分列表
  scoringList(paramsData) {
    return axios.get("/sale/scoring/list", { params: paramsData });
  },
  //提交打分表
  postScore(paramsData) {
    return axios.post("/sale/scoring/web/submit", paramsData);
  },
  //获取公司所有人员
  getCompanyPersons(paramsData) {
    return axios.post("/sale/scoring/web/staff/list", paramsData);
  },
  //获取公司所有人员
  getTeamAndProject(paramsData) {
    return axios.get("/sale/scoring/web/getTeamAndProject", {
      params: paramsData
    });
  },
  //获取打分记录
  getRecordScoreList(paramsData) {
    return axios.post("/sale/scoring/record/list", paramsData);
  },
  //获取打分详情
  scoredDetail(paramsData) {
    return axios.get("/sale/scoring/web/record/detail", { params: paramsData });
  },
  //获取销售业主列表
  selectSaleCustomer(paramsData) {
    return axios.get("/sale/workbench/selectSaleCustomer", {
      params: paramsData
    });
  },
  //获取短链接
  getLinkAddress(paramsData) {
    return axios.get("/sale/scoring/web/linkAddress", { params: paramsData });
  },
  //获取日志表
  getDailyData(paramsData) {
    return axios.get("/sale/my/daily/dailyData", { params: paramsData });
  },
  //  //获取百度token
  //  getBaiduToken(paramsData) {
  //     return axios.post('https://aip.baidubce.com/rest/2.0/ocr/v1/idcard?access_token="24.b721c1faf0310250744f462ee807a8a9.2592000.1636356601.282335-24961847', paramsData);
  // },
  //获取百度token
  getBaiduToken(paramsData) {
    return axios.get("/sale/idCard", { params: paramsData });
  },
  // //识别身份证
  // getIdCardSide(paramsData) {
  //     return axios.get('/sale/idCardImg', { params: paramsData });
  // },
  //统计-获取数据标签信息
  labelData(paramsData) {
    return axios.post(`/sale/workbench/selectCustomerTagData`, paramsData);
  },
  //获取待退款列表
  refundCheckList(paramsData) {
    return axios.post(`/sale/refundCheck/todoList`, paramsData);
  },
  //退款审核
  refundCheck(paramsData) {
    return axios.post(`/sale/refundCheck/check`, paramsData);
  },
  //只退资料费审核
  informationFeeRefundCheck(paramsData) {
    return axios.post(`/sale/informationFeeRefund/refundCheck`, paramsData);
  },
  //待退款详情（只退资料费）
  informationFeeRefundDetail(paramsData) {
    return axios.get(`/sale/informationFeeRefund/detail`, {
      params: paramsData
    });
  },
  //获取退款审核
  getRefundCheck(paramsData) {
    return axios.get("/sale/refundCheck/detail", { params: paramsData });
  },
  //获取期数
  getNumberPeriods(paramsData) {
    return axios.get("/sale/customer/getNumberPeriods", { params: paramsData });
  },
  //助攻跟进
  addFlag(paramsData) {
    return axios.post("/sale/customer/follow/addFlag", paramsData);
  },
  //获取车位列表期数
  getPackNumberPeriods(paramsData) {
    return axios.get("/sale/park/getNumberPeriods", { params: paramsData });
  },
  //项目详情-打分表
  projectRecord(paramsData) {
    return axios.post("/sale/scoring/projectRecord", paramsData);
  },
  //签约后续保存
  signFollowUp(paramsData) {
    return axios.post("/sale/buy/signFollowUp", paramsData);
  },
  //获取用户当天打卡信息
  currentList(paramsData) {
    return axios.get("/sale/clockOn/currentList", { params: paramsData });
  },
  //新增打卡
  addPunchClock(paramsData) {
    return axios.post("/sale/clockOn/add", paramsData);
  },
  //条件查询打卡列表
  punchClockList(paramsData) {
    return axios.post("/sale/clockOn/list", paramsData);
  },
  //查询打卡统计信息
  clockStatistics(paramsData) {
    return axios.post("/sale/clockOn/clockStatistics", paramsData);
  },
  //查询打卡统计信息
  clockStatisticsList(paramsData) {
    return axios.post("/sale/clockOn/clockStatisticsList", paramsData);
  },
  //1分钟内是否打卡
  isClock(paramsData) {
    return axios.get("/sale/clockOn/isClock", { params: paramsData });
  },
  //项目库存记录
  reserveLogList(paramsData) {
    return axios.get("/sale/project/manage/reserveLog", { params: paramsData });
  },
  //作废补交服务费
  serviceFeeDel(paramsData) {
    return axios.post("/sale/buy/serviceFeeDel", paramsData);
  },
  //首页是否去打卡
  isEffectiveClock(paramsData) {
    return axios.get("/sale/clockOn/isEffectiveClock", { params: paramsData });
  },
  //是否在时间内打卡
  isSlotClock(paramsData) {
    return axios.get("/sale/clockOn/isSlotClock", { params: paramsData });
  },
  //获取文件模版
  projectFileTemplate(paramsData) {
    return axios.get("/sale/project/manage/projectFileTemplate", {
      params: paramsData
    });
  },
  //获取打卡位置
  getLocation(paramsData) {
    return axios.get("/sale/clockOn/getLocation", { params: paramsData });
  },
  //获取业主ID
  selectCustomerId(paramsData) {
    return axios.post("/sale/customer/selectCustomerId", paramsData);
  },
  //获取视频列表
  getCourseVideoList(paramsData) {
    return axios.post("/sale/course/list", paramsData);
  },
  //获取视频详情
  getCourseVideoDetail(paramsData) {
    return axios.get("/sale/course/detail", { params: paramsData });
  },
  //获取未签约数据统计信息
  selectDataParse(paramsData) {
    return axios.post("/sale/workbench/selectDataParse", paramsData);
  },
  //获取未签约数据统计信息列表
  notSignList(paramsData) {
    return axios.post("/sale/workbench/notSignList", paramsData);
  },
  //获取通讯录职位筛选
  getRoleLevelList(paramsData) {
    return axios.get("/sale/role/roleLevelList", { params: paramsData });
  },
  //获取通讯录列表
  getAddressBookList(paramsData) {
    return axios.post("/sale/addressBook/list", paramsData);
  },
  //获取通讯录员工项目
  currentStaffProjectList(paramsData) {
    return axios.get("/sale/project/manage/currentStaffProjectList", {
      params: paramsData
    });
  },
  //获取团队管理-项目
  getAllProjectTeam(paramsData) {
    return axios.post("/sale/manager/allProjectTeam", paramsData);
  },
  //获取团队管理-经理
  getAllTeamProject(paramsData) {
    return axios.post("/sale/manager/allTeamProject", paramsData);
  },
  //获取通讯录员工详情
  getStaffDetail(paramsData) {
    return axios.get("/sale/addressBook/detail", { params: paramsData });
  },
  //查询预算待审核
  giftCheckList(paramsData) {
    return axios.post("/sale/workbench/giftCheckList", paramsData);
  },
  //获取预算信息
  getGiftDetail(paramsData) {
    return axios.get("/sale/workbench/giftDetail", { params: paramsData });
  },
  //预算待审核
  giftCheck(paramsData) {
    return axios.post("/sale/workbench/giftCheck", paramsData);
  },
  //已打盘项目
  hisProjectList(paramsData) {
    return axios.post("/sale/workbench/hisProjectList", paramsData);
  },
  //设置守盘，保留人员
  setStaffStatus(paramsData) {
    return axios.post("/sale/manager/setStaffStatus", paramsData);
  },
  //销售经理分配权限
  managerQxTask(paramsData) {
    return axios.post("/sale/project/manage/managerQxTask", paramsData);
  },
  //获取销售经理权限任务接口
  getManagerTask(paramsData) {
    return axios.get("/sale/project/manage/getManagerTask", {
      params: paramsData
    });
  },
  //分享通话
  getCallListForStaffAll(paramsData) {
    return axios.post(`/sale/call/callList`, paramsData);
  },
  //点赞或者踩
  addPraise(paramsData) {
    return axios.post(`/sale/call/addPraise`, paramsData);
  },
  //逾期签约申请
  addServiceNotSign(paramsData) {
    return axios.post(`/sale/buy/addServiceNotSign`, paramsData);
  },
  //获取逾期未签约审核详情
  getNotSignDetail(paramsData) {
    return axios.get("/sale/buy/notSignDetail", { params: paramsData });
  },
  //未签约审核
  notSignCheck(paramsData) {
    return axios.post(`/sale/workbench/notSignCheck`, paramsData);
  },
  //现金收款-未转交现金列表
  notTransferList(paramsData) {
    return axios.post(`/sale/cash/notTransferList`, paramsData);
  },
  //现金收款-获取现金接收职位及数据
  receiveRoleInfo(paramsData) {
    return axios.get("/sale/cash/receiveRoleInfo", { params: paramsData });
  },
  //现金收款-待接收现金列表
  pendingList(paramsData) {
    return axios.post(`/sale/cash/pendingList`, paramsData);
  },
  //现金收款-未转交现金统计
  notTransferTotalMoneyAndCount(paramsData) {
    return axios.get("/sale/cash/notTransferTotalMoneyAndCount", {
      params: paramsData
    });
  },
  //现金收款-转交现金
  transfer(paramsData) {
    return axios.post(`/sale/cash/transfer`, paramsData);
  },
  //资料费收款-转交现金
  infoFeeTransfer(paramsData) {
    return axios.post(`/sale/informationFee/transfer`, paramsData);
  },
  //现金收款-接收现金
  receiveCash(paramsData) {
    return axios.post(`/sale/cash/receive`, paramsData);
  },
  //现金收款-转交给出纳
  transferCashier(paramsData) {
    return axios.post(`/sale/cash/transferCashier`, paramsData);
  },
  //现金收款-转交给督查
  transferSupervision(paramsData) {
    return axios.post(`/sale/cash/transferOther`, paramsData);
  },
  //现金收款-获取出纳人员
  getCashiers(paramsData) {
    return axios.get("/sale/cash/getCashiers", { params: paramsData });
  },
  //资料费收款-获取出纳人员
  getInfoCashiers(paramsData) {
    return axios.get("/sale/informationFee/getCashiers", {
      params: paramsData
    });
  },
  //现金收款-转交记录
  transferHistoryList(paramsData) {
    return axios.post(`/sale/cash/transferHistoryList`, paramsData);
  },
  //资料费收款-转交记录
  infoTransferHistoryList(paramsData) {
    return axios.post(`/sale/informationFee/transferHistoryList`, paramsData);
  },
  //现金收款-拒绝
  transferReject(paramsData) {
    return axios.post(`/sale/cash/reject`, paramsData);
  },
  //获取是否填写开盘时间和撤场时间信息
  selectOpenOutTime(paramsData) {
    return axios.post(`/sale/workbench/selectOpenOutTime`, paramsData);
  },
  //现金收款-转交记录
  cashDetail(paramsData) {
    return axios.get(`/sale/cash/detail`, { params: paramsData });
  },
  //根据hisId获取在场销售
  currentSaleStaff(paramsData) {
    return axios.get(`/sale/manager/currentSaleStaff`, { params: paramsData });
  },
  //一键释放业主
  releaseCustomer(paramsData) {
    return axios.post(`/sale/project/manage/releaseCustomer`, paramsData);
  },
  //获取所有销售
  allSale(paramsData) {
    return axios.get(`/sale/manager/allSale`, { params: paramsData });
  },
  //获取所有部长
  allMinister(paramsData) {
    return axios.get(`/sale/manager/allMinister`, { params: paramsData });
  },
  //获取该公司下所有部长和督导
  ministerAndSupervision(paramsData) {
    return axios.get(`/sale/manager/ministerAndSupervision`, {
      params: paramsData
    });
  },
  //获取核算项目
  getCheckProjectList(paramsData) {
    return axios.post(`/sale/inventory/list`, paramsData);
  },
  //锁定解锁
  closeReserve(paramsData) {
    return axios.post(`/sale/inventory/closeReserve`, paramsData);
  },
  //保存项目库存
  saveInventory(paramsData) {
    return axios.post(`/sale/inventory/saveInventory`, paramsData);
  },
  //库存盘点详情溢出
  getInventoryDetail(paramsData) {
    return axios.get(`/sale/inventory/inventoryDetail`, { params: paramsData });
  },
  //库存盘点详情
  getPDreserveDetail(paramsData) {
    return axios.get(`/sale/inventory/reserveDetail`, { params: paramsData });
  },
  //库存盘点记录
  inventoryLog(paramsData) {
    return axios.post(`/sale/inventory/inventoryLog`, paramsData);
  },
  //获取盘点状态
  getInventoryStatus(paramsData) {
    return axios.get(`/sale/inventory/getInventoryStatus`, {
      params: paramsData
    });
  },
  //获取当前项目所有销售
  getAllSale(paramsData) {
    return axios.get(`/sale/target/getAllSale`, { params: paramsData });
  },
  //保存今日目标
  targetAdd(paramsData) {
    return axios.post(`/sale/target/add`, paramsData);
  },
  //检查今日目标
  targetCheck(paramsData) {
    return axios.post(`/sale/target/sureCheckCompletion`, paramsData);
  },
  //获取今日目标
  targetGet(paramsData) {
    return axios.get(`/sale/target/get`, { params: paramsData });
  },
  //历史目标
  getObjectHistory(paramsData) {
    return axios.get(`/sale/target/getHistory`, { params: paramsData });
  },
  //目标统计
  getDailyStatistics(paramsData) {
    return axios.get(`/sale/target/dailyStatistics`, { params: paramsData });
  },
  //每日考核-获取日报表
  projectTargetDay(paramsData) {
    return axios.post(`/sale/target/projectTargetDay`, paramsData);
  },
  //每日考核-获取月报表
  projectTargetMonth(paramsData) {
    return axios.post(`/sale/target/projectTargetMonth`, paramsData);
  },
  //每日考核-获取听录音情况
  projectTargetDaySound(paramsData) {
    return axios.post(`/sale/target/projectTargetDaySound`, paramsData);
  },
  //已购产位
  buyParkList(paramsData) {
    return axios.get(`/sale/customer/buyParkList`, { params: paramsData });
  },
  //项目榜单
  topList(paramsData) {
    return axios.get(`/sale/workbench/projectTopList`, { params: paramsData });
  },
  //年度/累计榜单
  yearTopList(paramsData) {
    return axios.get(`/sale/workbench/topList`, { params: paramsData });
  },
  //获取有年度榜单的年份数据
  getYearData(paramsData) {
    return axios.get(`/sale/workbench/topListDate`, { params: paramsData });
  },
  //获取地锁供应商
  getGroundLockSupplierList(paramsData) {
    return axios.get(`/sale/park/getGroundLockSupplierList`, {
      params: paramsData
    });
  },
  //经理 录音 （已听记录）
  addSoundPlayRecord(paramsData) {
    return axios.post(`/sale/soundPlayRecord/add`, paramsData);
  },
  //薪资
  getStaffSalaryList(paramsData) {
    return axios.get(`/sale/staffSalary/list`, { params: paramsData });
  },
  //薪资详情
  getStaffSalaryDetail(paramsData) {
    return axios.get(`/sale/staffSalary/detail`, { params: paramsData });
  },
  //自定义标签
  customTagChange(paramsData) {
    return axios.post(`/sale/customer/customTag/change`, paramsData);
  },
  //数据表
  getDataSheetDetail(paramsData) {
    return axios.get(`/sale/project/manage/dataSheet/detail`, {
      params: paramsData
    });
  },
  //数据表
  updateDataSheet(paramsData) {
    return axios.post(`/sale/project/manage/dataSheet/update`, paramsData);
  },
  /*************************************商城API******************************************************************************************* */
  //获取验证码--商城积分
  sendCode(paramsData) {
    return axios.post(
      base.cUrl + `/api/front/sendCode?phone=` + paramsData.phone,
      paramsData
    );
  },
  //商城积分记录
  getBillLog(paramsData) {
    return axios.get(`/sale/customer/billLog`, { params: paramsData });
  },
  //新增优惠设置
  addDiscount(paramsData) {
    return axios.post(`/sale/customer/discount/add`, paramsData);
  },
  //修改优惠设置
  updateDiscount(paramsData) {
    return axios.post(`/sale/customer/discount/update`, paramsData);
  },
  //业主优惠记录
  getDiscountRecord(paramsData) {
    return axios.get(`/sale/customer/discount/record`, { params: paramsData });
  },
  //优惠列表
  getDiscountList(paramsData) {
    return axios.post(`/sale/customer/discount/list`, paramsData);
  },
  //优惠列表审核
  checkDiscount(paramsData) {
    return axios.post(`/sale/customer/discount/check`, paramsData);
  },
  //优惠列表取消红点
  cancelDiscountRed(paramsData) {
    return axios.get(`/sale/customer/discount/undoRed`, { params: paramsData });
  },

  //工作台获取是否赠送商城积分
  workbenchselectSendMall(paramsData) {
    return axios.get(`/sale/workbench/selectSendMall`, { params: paramsData });
  },
  //获取商学院类别
  getBusinessCollegeType(paramsData) {
    return axios.get("/sale/school/getType", { params: paramsData });
  },
  //获取商学院列表
  getbusinessCollegeList(paramsData) {
    return axios.post("/sale/school/list", paramsData);
  },
  //获取商学院知识库(用于大礼连连后台访问)
  getbusinessCollegeListFromWx(paramsData) {
    return axios.post("/sale/school/allList", paramsData);
  },
  //获取商学院详情
  getBusinessCollegeDetail(paramsData) {
    return axios.get("/sale/school/getFileDetail", { params: paramsData });
  },
  //获取商学院视频评论
  getBusinessCollegeComment(paramsData) {
    return axios.get("/sale/school/getComment", { params: paramsData });
  },
  //商学院视频新增评论
  AddBusinessCollegeComment(paramsData) {
    return axios.post("/sale/school/addComment", paramsData);
  },
  //商学院视频点赞
  likeBusinessCollegeVideo(paramsData) {
    return axios.post("/sale/school/setLike", paramsData);
  },
  //获取朋友圈模板
  queryFriendCircleTemplate(paramsData) {
    return axios.get("/sale/school/friendsCircle", { params: paramsData });
  },
  //获取商学院-讲师列表
  getBusinessSchoolLecturer(paramsData) {
    return axios.get("/sale/businessSchoolLecturer/get", {
      params: paramsData
    });
  },
  //获取商学院-线下课堂列表
  getOfflinePage(paramsData) {
    return axios.post("/sale/offline/offlinePage", paramsData);
  },
  //获取商学院-线下课堂保存-上传听课本
  saveOffline(paramsData) {
    return axios.post("/sale/offline/save", paramsData);
  },
  //获取商学院-线下课堂详情
  offlineDetail(paramsData) {
    return axios.get("/sale/offline/detail", { params: paramsData });
  },
  //获取商学院-线下课堂保存-上传听课本
  uploadTextBook(paramsData) {
    return axios.post("/sale/offline/uploadTextBook", paramsData);
  },
  //最后一次优惠信息
  lastDiscount(paramsData) {
    return axios.get("/sale/customer/discount/lastDiscount", {
      params: paramsData
    });
  },
  //项目送礼记录查询
  projectGiftRecord(paramsData) {
    return axios.post("/sale/customer/projectGiftRecord", paramsData);
  },
  //获取发票报销类型
  reimbursementTypeList(paramsData) {
    return axios.get("/sale/reimbursement/typeList", { params: paramsData });
  },
  //报销项目列表
  reimbursementProjectList(paramsData) {
    return axios.post("/sale/reimbursement/projectList", paramsData);
  },
  //获取费用归属公司
  getCollectionAccount(paramsData) {
    return axios.get("/sale/collectionAccount/list", { params: paramsData });
  },
  //日常报销提交
  reimbursementSave(paramsData) {
    return axios.post("/sale/reimbursement/save", paramsData);
  },
  //日常报销作废
  reimbursementCancel(paramsData) {
    return axios.post("/sale/reimbursement/cancel", paramsData);
  },
  //付款申请作废
  paymentApplicationCancel(paramsData) {
    return axios.post("/sale/paymentApplication/cancel", paramsData);
  },
  //获取外部收款账户列表
  getExternalCollectionAccountList(paramsData) {
    return axios.get("/sale/externalCollectionAccount/list", {
      params: paramsData
    });
  },
  //删除外部收款账户
  delExternalCollectionAccount(paramsData) {
    return axios.post("/sale/externalCollectionAccount/del", paramsData);
  },
  //编辑外部收款账户
  editExternalCollectionAccount(paramsData) {
    return axios.post("/sale/externalCollectionAccount/edit", paramsData);
  },
  //获取付款类型
  getPaymentApplicationType(paramsData) {
    return axios.get("/sale/paymentApplication/paymentType", {
      params: paramsData
    });
  },
  //日常报销列表
  reimbursementList(paramsData) {
    return axios.post("/sale/reimbursement/list", paramsData);
  },
  //付款申请获取项目场次
  getSelectProjectHis(paramsData) {
    return axios.get("/sale/paymentApplication/selectProjectHis", {
      params: paramsData
    });
  },
  //提交付款申请
  savePaymentApplication(paramsData) {
    return axios.post("/sale/paymentApplication/save", paramsData);
  },
  //审核付款申请-出纳相关数据保存
  saveUpdatePaymentApplication(paramsData) {
    return axios.post("/sale/paymentApplication/update", paramsData);
  },
  //审核付款申请上传发票
  uploadInvoicePaymentApplication(paramsData) {
    return axios.post("/sale/paymentApplication/uploadInvoice", paramsData);
  },
  //付款申请详情
  getPaymentApplicationDetail(paramsData) {
    return axios.get("/sale/paymentApplication/detail", { params: paramsData });
  },
  //付款流程撤回
  paymentApplicationWithdrawn(paramsData) {
    return axios.post("/sale/act/paymentApplication/withdrawn", paramsData);
  },
  //付款流程审核
  paymentApplicationCompleteAudit(paramsData) {
    return axios.post("/sale/act/paymentApplication/complete", paramsData);
  },
  //OA待处理列表
  getOAPendingList(paramsData) {
    return axios.post("/sale/act/pendingList", paramsData);
  },
  //获取日常报销详情
  getrReimbursementDetail(paramsData) {
    return axios.get("/sale/reimbursement/detail", { params: paramsData });
  },
  //获取ai日常报销详情
  getrReimbursementDetailAi(paramsData) {
    return axios.get("/sale/reimbursement/aiAnalyzesInvoiceInformation", { params: paramsData });
  },
  //获取流程信息
  getCheckInfo(paramsData) {
    return axios.get("/sale/act/checkInfo", { params: paramsData });
  },
  //日常报销撤回
  dailyPayWithdrawn(paramsData) {
    return axios.post(
      "/sale/act/reimbursement/withdrawn?billId=" + paramsData.billId,
      paramsData
    );
  },
  //日常报审核
  dailyPayCompleteAudit(paramsData) {
    return axios.post("/sale/act/reimbursement/complete", paramsData);
  },
  //我发起的待付款列表
  paymentApplicationList(paramsData) {
    return axios.post("/sale/paymentApplication/list", paramsData);
  },
  //oa待处理统计
  pendingSelect(paramsData) {
    return axios.get("/sale/reimbursement/pendingSelect", {
      params: paramsData
    });
  },
  //发票数量查询
  invoiceSelect(paramsData) {
    return axios.get("/sale/reimbursement/invoiceSelect", {
      params: paramsData
    });
  },
  //OA我发起的
  mySendList(paramsData) {
    return axios.post("/sale/act/mySendList", paramsData);
  },
  //OA我收到的
  hisList(paramsData) {
    return axios.post("/sale/act/hisList", paramsData);
  },
  //历史标签
  historyTags(paramsData) {
    return axios.get("/sale/customer/historyTags", { params: paramsData });
  },
  //服务费撤回
  serviceWithdraw(paramsData) {
    return axios.post("/sale/buy/serviceWithdraw", paramsData);
  },
  //已经结算车位管理费
  parkManageMoney(paramsData) {
    return axios.get("/sale/buy/parkManageMoney", { params: paramsData });
  },
  //抄送我的
  ccList(paramsData) {
    return axios.post("/sale/act/ccList", paramsData);
  },
  //获取催收信息(场次id)
  selectPressMoneyInfoByHisId(paramsData) {
    return axios.get("/sale/pressMoney/selectPressMoneyInfoByHisId", {
      params: paramsData
    });
  },
  //催收新增/结束
  pressMoneySave(paramsData) {
    return axios.post("/sale/pressMoney/save", paramsData);
  },
  //催收作废
  pressMoneyDel(paramsData) {
    return axios.post("/sale/pressMoney/del", paramsData);
  },
  //催收列表
  pressMoneyList(paramsData) {
    return axios.post("/sale/pressMoney/pressMoneyList", paramsData);
  },
  //获取催收信息(催收id)
  selectPressMoneyInfoByPressId(paramsData) {
    return axios.get("/sale/pressMoney/selectPressMoneyInfoByPressId", {
      params: paramsData
    });
  },
  //获取催收信息时间轴
  selectFollowTimeByPressId(paramsData) {
    return axios.get("/sale/pressMoney/selectFollowTimeByPressId", {
      params: paramsData
    });
  },
  //获催收详情
  selectFollowDetailByPressId(paramsData) {
    return axios.get("/sale/pressMoney/selectFollowDetailByPressId", {
      params: paramsData
    });
  },
  //获商务条款详情
  selectContractDetail(paramsData) {
    return axios.get("/sale/pressMoney/selectContractDetail", {
      params: paramsData
    });
  },
  //获取催收项目列表
  getPressMoneyProjectList(paramsData) {
    return axios.post(`/sale/pressMoney/getProjectList`, paramsData);
  },
  //获取借用记录
  getBorrowList(paramsData) {
    return axios.get("/sale/borrow/borrowList", { params: paramsData });
  },
  //设置借用状态
  setBorrowCheck(paramsData) {
    return axios.post(`/sale/borrow/borrowCheck`, paramsData);
  },
  //作废借用数据
  voidData(paramsData) {
    return axios.post(`/sale/borrow/myBorrowCancel`, paramsData);
  },
  //获取收据借用详情
  receiptBorrowDetail(paramsData) {
    return axios.get("/sale/borrow/receiptBorrowDetail", {
      params: paramsData
    });
  },
  //收据借用归还申请
  receiptBorrowReturnCheck(paramsData) {
    return axios.post(`/sale/borrow/receiptBorrowReturnCheck`, paramsData);
  },
  //获取合同列表列表
  getContractManage(paramsData) {
    return axios.post(`/sale/pressMoney/getContractManage`, paramsData);
  },
  //获取催收信息(合同id)
  selectPressMoneyInfoByContractId(paramsData) {
    return axios.get("/sale/pressMoney/selectPressMoneyInfoByContractId", {
      params: paramsData
    });
  },
  //复盘表埋点
  buryPointAdd(paramsData) {
    return axios.post(`/sale/buryPoint/add`, paramsData);
  },
  //获取催收信息(合同id)
  purchaseDetail(paramsData) {
    return axios.get("/sale/purchase/detail", { params: paramsData });
  },
  //发起采购
  savePurchase(paramsData) {
    return axios.post(`/sale/purchase/save`, paramsData);
  },
  //库存列表信息
  getReserve(paramsData) {
    return axios.post(`/sale/purchase/getReserve`, paramsData);
  },
  //采购撤回
  purchaseWithdrawn(paramsData) {
    return axios.post(`/sale/act/purchase/withdrawn`, paramsData);
  },
  //采购作废
  purchaseCancel(paramsData) {
    return axios.post(`/sale/purchase/cancel`, paramsData);
  },
  //采购通过
  purchaseComplete(paramsData) {
    return axios.post(`/sale/act/purchase/complete`, paramsData);
  },
  //采购获取地址
  purchaseAddress(paramsData) {
    return axios.get(`/sale/purchase/purchaseAddress`, { params: paramsData });
  },
  //采购获取统计
  selectPurchasePrice(paramsData) {
    return axios.get(`/sale/purchase/selectPurchasePrice`, {
      params: paramsData
    });
  },
  //获取渠道佣金
  getGuestFee(paramsData) {
    return axios.get("/sale/project/manage/guestFee", { params: paramsData });
  },
  //商品反馈
  productFeedbackSave(paramsData) {
    return axios.post(`/sale/customer/productFeedbackSave`, paramsData);
  },
  //反馈商品列表
  getFeedbackReserveByProjectHid(paramsData) {
    return axios.get(`/sale/customer/getFeedbackReserveByProjectHid`, {
      params: paramsData
    });
  },
  //合同借出
  contractBorrowApply(paramsData) {
    return axios.post(`/sale/borrow/contractBorrowApply`, paramsData);
  },
  //物品借出
  goodsBorrowApply(paramsData) {
    return axios.post(`/sale/borrow/goodsBorrowApply`, paramsData);
  },
  //合同借出审核
  contractBorrowCheck(paramsData) {
    return axios.post(`/sale/borrow/contractBorrowCheck`, paramsData);
  },
  //收据借出
  receiptBorrowApply(paramsData) {
    return axios.post(`/sale/borrow/receiptBorrowApply`, paramsData);
  },
  //获取签约项目及其关联合同
  signProject(paramsData) {
    return axios.get(`/sale/borrow/signProject`, { params: paramsData });
  },
  //pk列表
  pkProjectList(paramsData) {
    return axios.post(`/sale/pk/list`, paramsData);
  },
  //支付
  commonPay(paramsData) {
    return axios.post(`/sale/pay/pay`, paramsData);
  },
  //我的PK
  myPKInfo(paramsData) {
    return axios.post(`/sale/pk/myPk`, paramsData);
  },
  //pk回调
  changePayStatus(paramsData) {
    return axios.post(`/sale/pay/payStatus`, paramsData);
  },
  //判断能否支付
  isCanPay(paramsData) {
    return axios.post(`/sale/pay/status`, paramsData);
  },
  //pk详情
  getPKDetail(paramsData) {
    return axios.get(`/sale/pk/pkPerson`, { params: paramsData });
  },
  //pk金额
  getPKNumber(paramsData) {
    return axios.post(`/sale/pk/statistics`, paramsData);
  },
  //问卷调查-项目列表
  questionProjectList(paramsData) {
    return axios.post(`/sale/question/projectList`, paramsData);
  },
  //问卷调查-业主修改
  questionCustomerUpdate(paramsData) {
    return axios.post(`/sale/question/customerUpdate`, paramsData);
  },
  //问卷调查-业主集合
  questionCustomerList(paramsData) {
    return axios.post(`/sale/question/customerList`, paramsData);
  },
  //问卷调查-业主详情
  questionCustomerDetail(paramsData) {
    return axios.get(`/sale/question/customerDetail`, { params: paramsData });
  },
  //问卷调查-业主详情-通话记录
  questionCall(paramsData) {
    return axios.get(`/sale/question/call`, { params: paramsData });
  },
  //问卷调查-业主ids
  questionSelectCustomerId(paramsData) {
    return axios.post(`/sale/question/selectCustomerId`, paramsData);
  },
  //问卷调查-销售
  questionAllSale(paramsData) {
    return axios.get(`/sale/question/allSale`, { params: paramsData });
  },
  //问卷调查报告
  questionSaveRemark(paramsData) {
    return axios.post(`/sale/question/saveRemark`, paramsData);
  },
  //话术列表
  verbalTrickList(paramsData) {
    return axios.get(`/sale/project/verbalTrick/list`, { params: paramsData });
  },
  //新增话术
  verbalTrickAdd(paramsData) {
    return axios.post(`/sale/project/verbalTrick/add`, paramsData);
  },
  //编辑话术
  verbalTrickEdit(paramsData) {
    return axios.post(`/sale/project/verbalTrick/update`, paramsData);
  },
  //话术审核列表
  verbalTrickAuditList(paramsData) {
    return axios.post(`/sale/project/verbalTrick/pendingList`, paramsData);
  },
  //审核话术
  verbalTrickPass(paramsData) {
    return axios.post(`/sale/project/verbalTrick/pass`, paramsData);
  },
  //审核话术并通过
  verbalTrickUpdateAndPass(paramsData) {
    return axios.post(`/sale/project/verbalTrick/updateAndPass`, paramsData);
  },
  //流程策略列表
  policeLibList(paramsData) {
    return axios.post(`/sale/policeLib/list`, paramsData);
  },
  //流程话术列表
  speechLibList(paramsData) {
    return axios.post(`/sale/speechLib/list`, paramsData);
  },
  //录音分享-评论列表
  commentList(paramsData) {
    return axios.post(`/sale/call/comment/list`, paramsData);
  },
  //录音分享-新增评论
  commentAdd(paramsData) {
    return axios.post(`/sale/call/comment/add`, paramsData);
  },
  //录音分享-评论统计
  commentTotal(paramsData) {
    return axios.post(`/sale/call/comment/total`, paramsData);
  },
  //抵押文件列表
  contractMortgageList(paramsData) {
    return axios.get(`/sale/ContractMortgage/list`, { params: paramsData });
  },
  //抵押文件-解押
  dischargeMortgage(paramsData) {
    return axios.post(`/sale/ContractMortgage/dischargeMortgage`, paramsData);
  },
  //抵押文件-抵押记录
  contractMortgageLog(paramsData) {
    return axios.get(`/sale/ContractMortgage/contractMortgageLog`, {
      params: paramsData
    });
  },
  //抵押文件-解押记录
  contractDischargeMortgageLog(paramsData) {
    return axios.get(`/sale/ContractMortgage/contractDischargeMortgageLog`, {
      params: paramsData
    });
  },
  //我的-我的师傅
  selectTeacherInfo(paramsData) {
    return axios.get(`/sale/my/staff/selectTeacherInfo`, {
      params: paramsData
    });
  },
  //获取待撤场项目
  getDialogShowoutTimeAlert(paramsData) {
    return axios.get(`/sale/workbench/outTimeAlert`, { params: paramsData });
  },
  //获取条件查询项目业主列表
  getSelectSaleCustomer(paramsData) {
    return axios.post(`/sale/customer/selectSaleCustomer`, paramsData);
  },
  //业主未签约跟进模块-写跟进
  addServiceNotSignFollow(paramsData) {
    return axios.post(`/sale/customer/serviceNotSignFollow/add`, paramsData);
  },
  //业主未签约跟进模块-跟进记录
  serviceNotSignFollowRecord(paramsData) {
    return axios.get(`/sale/customer/serviceNotSignFollow/record`, {
      params: paramsData
    });
  },
  //逾期未签约详情
  overduefollowRecord(paramsData) {
    return axios.get(`sale/customer/serviceNotSignFollow/recordDetail`, {
      params: paramsData
    });
  },
  //oa 遗失报损数量
  pendingLostNum(paramsData) {
    return axios.get(`/sale/reserve/lostProgress/pendingCount`, {
      params: paramsData
    });
  },
  //公告收藏
  announcementCollect(paramsData) {
    return axios.post(`/sale/announcement/collect`, paramsData);
  },
  //人员积分
  getStaffIntegral(paramsData) {
    return axios.get(`/sale/staffIntegral/get`, { params: paramsData });
  },
  //违纪
  getStaffViolation(paramsData) {
    return axios.get(`/sale/staffViolation/get`, { params: paramsData });
  },

  //服务协议申请列表
  getServiceAgreementWaitApply(paramsData) {
    return axios.get(`/sale/serviceAgreement/serviceAgreementWaitApply`, {
      params: paramsData
    });
  },
  //服务协议申请列表人员
  getRecipientStaff(paramsData) {
    return axios.get(`/sale/serviceAgreement/getRecipientStaff`, {
      params: paramsData
    });
  },
  //服务协议转交
  serviceAgreementSubmit(paramsData) {
    return axios.post(`/sale/serviceAgreement/submit`, paramsData);
  },
  //服务协议申请记录列表
  mySubmitServiceAgreementList(paramsData) {
    return axios.get(`/sale/serviceAgreement/mySubmitServiceAgreement`, {
      params: paramsData
    });
  },
  //服务协议审核记录列表
  myRecipientServiceAgreement(paramsData) {
    return axios.get(`/sale/serviceAgreement/myRecipientServiceAgreement`, {
      params: paramsData
    });
  },
  //服务协议转交售后
  checkServiceAgreement(paramsData) {
    return axios.post(
      `/sale/serviceAgreement/checkServiceAgreement`,
      paramsData
    );
  },
  //服务协议审核状态数量
  checkStatus(paramsData) {
    return axios.get(`/sale/serviceAgreement/checkStatus`, {
      params: paramsData
    });
  },
  //获取员工个人积分
  staffPersonalIntegral(paramsData) {
    return axios.get(`/sale/staffIntegral/staffPersonalIntegral`, {
      params: paramsData
    });
  },
  //流程查看商城商品列表
  selectProduct(paramsData) {
    return axios.post(`/sale/mall/selectProduct`, paramsData);
  },
  //线上开盘 订单列表
  orderList(paramsData) {
    return axios.post(`/sale/online/orderList`, paramsData);
  },
  //线上开盘 订单详情
  projectOnlineDetail(paramsData) {
    return axios.get(`/sale/online/projectOnlineDetail`, {
      params: paramsData
    });
  },
  //线上开盘 订单退款
  payRefund(paramsData) {
    return axios.post(
      "https://app.jinbaniu.com" + `/wechatSale/online/payRefund`,
      paramsData
    );
  },
  //线上开盘 开启信息
  setProjectSaleOnline(paramsData) {
    return axios.post(`/sale/project/manage/setProjectSaleOnline`, paramsData);
  },
  //设置注水
  setFalseState(paramsData) {
    return axios.post(`/sale/park/setFalseState`, paramsData);
  },
  //统计导出
  statisticsExport(paramsData) {
    return axios.get(`/sale/workbench/statisticsExport`, {
      responseType: "blob"
    });
  },
  //报废车位
  scrapList(paramsData) {
    return axios.get(
      `/sale/park/scrapList?hisId=` + paramsData.hisId,
      paramsData
    );
  },
  //修改车位列表
  getParkPriceChangeRecord(paramsData) {
    return axios.get(`/sale/park/getParkPriceChangeRecord`, {
      params: paramsData
    });
  },
  //新增车位
  addPark(paramsData) {
    return axios.post(`/sale/park/addPark`, paramsData);
  },
  //pk退款申请列表
  pkFlowList(paramsData) {
    return axios.post(`/sale/pk/pkFlowList`, paramsData);
  },
  //pk退款申请
  pkFlowCheck(paramsData) {
    return axios.post(`/sale/pk/pkFlowCheck`, paramsData);
  },
  //获取PK退款信息
  getPKFlowDetail(paramsData) {
    return axios.get(`/sale/pk/flowDetail`, { params: paramsData });
  },
  //pk退款审核
  pkAuditFlowCheck(paramsData) {
    return axios.post(`/sale/pk/flowCheck`, paramsData);
  },
  //三方对接-写跟进
  threeFollowSave(paramsData) {
    return axios.post(`/sale//three/follow/save`, paramsData);
  },
  //三方对接-跟进记录
  threeFollowList(paramsData) {
    return axios.get(`/sale/three/follow/list`, { params: paramsData });
  },
  //项目踩盘列表
  firstInfoList(paramsData) {
    return axios.post(`/sale/project/firstInfo/list`, paramsData);
  },
  //保存项目踩盘
  saveCollectInfo(paramsData) {
    return axios.post(`/sale/project/firstInfo/save`, paramsData);
  },
  //项目踩盘详情
  firstInfoDetail(paramsData) {
    return axios.get(`/sale/project/firstInfo/detail`, { params: paramsData });
  },
  //查询所有项目
  allProjectList(paramsData) {
    return axios.post(`/sale/project/manage/allProjectList`, paramsData);
  },
  //创建项目（名称+地址
  createProject(paramsData) {
    return axios.post(`/sale/project/manage/createProject`, paramsData);
  },
  //获取通用弹框
  getSystemAlert(paramsData) {
    return axios.get(`/sale/workbench/systemAlert`, { params: paramsData });
  },
  //待办事项 列表
  getToDoList(paramsData) {
    return axios.get(`/sale/pending/toDoList/get`, { params: paramsData });
  },
  //合同商务条款详情
  contractManageCommercialTerms(paramsData) {
    return axios.get(
      `/sale/contractManageCheck/contractManageCommercialTerms`,
      { params: paramsData }
    );
  },
  //项目推演详情
  warGameInfo(paramsData) {
    return axios.get(`/sale/project/warGame/invitation/info`, {
      params: paramsData
    });
  },
  //项目项目推演详情
  warGameDetail(paramsData) {
    return axios.get(`/sale/project/warGame/detail`, { params: paramsData });
  },
  //项目项目推演
  saveGame(paramsData) {
    return axios.post(`/sale/project/warGame/save`, paramsData);
  },
  //项目项目推演邀请提交
  warGameSave(paramsData) {
    return axios.post(`/sale/project/warGame/invitation/complete`, paramsData);
  },
  //获取周计划列表
  getWeeklyPlan(paramsData) {
    return axios.get(`/sale/weeklyPlan/get`, { params: paramsData });
  },
  //提交周计划
  weeklyPlanSubmit(paramsData) {
    return axios.post(`/sale/weeklyPlan/submit`, paramsData);
  },
  //获取周计划详情
  getWeeklyPlanDetail(paramsData) {
    return axios.get(`/sale/weeklyPlan/detail`, { params: paramsData });
  },
  //审核周计划
  weeklyPlanCheck(paramsData) {
    return axios.post(`/sale/weeklyPlan/check`, paramsData);
  },
  //token刷新
  refreshToken(paramsData) {
    return axios.post(`/sale/refreshToken`, paramsData);
  },
  //获取action
  getActions(paramsData) {
    return axios.get(`/sale/actions`, { params: paramsData });
  },
  //获取周计划统计
  newWeeklyPlan(paramsData) {
    return axios.get(`/sale/weeklyPlan/newWeeklyPlan`, { params: paramsData });
  },
  //获取微信聊天业主列表
  chatCustomerList(paramsData) {
    return axios.post(`/sale/customer/chat/customerList`, paramsData);
  },
  //获取微信聊天详情
  chatListDetail(paramsData) {
    return axios.post(`/sale/customer/chat/chatList`, paramsData);
  },
  //获取微信聊天音频
  wechatAmrTrans(paramsData) {
    return axios.get(`/sale/customer/chat/wechatAmrTrans`, {
      params: paramsData
    });
  },
  //推荐人审核列表
  referrerPage(paramsData) {
    return axios.post(`/sale/project/referrer/referrerPage`, paramsData);
  },
  //推荐人列表-审核
  referrerCheck(paramsData) {
    return axios.post(`/sale/project/referrer/check`, paramsData);
  },
  //签约后送礼-审核
  signGiftCheck(paramsData) {
    return axios.post(`/sale/customer/signGift/check`, paramsData);
  },
  //签约后送礼-列表
  signGiftList(paramsData) {
    return axios.post(`/sale/customer/signGift/list`, paramsData);
  },
  //签约后送礼-记录
  signGiftRecord(paramsData) {
    return axios.get(`/sale/customer/signGift/record`, { params: paramsData });
  },
  //周计划待处理数量
  pendingWeekCount(paramsData) {
    return axios.get(`/sale/weeklyPlan/pendingCount`, { params: paramsData });
  },
  //工作台-服务费待查看列表
  workbenchServiceList(paramsData) {
    return axios.post(`/sale/workbench/serviceList`, paramsData);
  },
  //项目推演前提详情
  preDetail(paramsData) {
    return axios.get(`/sale/project/warGame/preDetail`, { params: paramsData });
  },
  //获取项目支援列表
  getProjectHelp(paramsData) {
    return axios.get(`/sale/projectHelp/get`, { params: paramsData });
  },
  //获取项目支援项目
  getProjectHelpProject(paramsData) {
    return axios.get(`/sale/projectHelp/project`, { params: paramsData });
  },
  //提交支援项目申请
  projectHelpCreateApply(paramsData) {
    return axios.post(`/sale/projectHelp/createApply`, paramsData);
  },
  //获取项目支援项目详情
  projectHelpApplyDetail(paramsData) {
    return axios.get(`/sale/projectHelp/applyDetail`, { params: paramsData });
  },
  //审核支援项目申请
  projectHelpCheck(paramsData) {
    return axios.post(`/sale/projectHelp/check`, paramsData);
  },
  //提交支援项目打卡
  projectHelpSignIn(paramsData) {
    return axios.post(`/sale/projectHelp/signIn`, paramsData);
  },
  //统计微信数据
  wechatStatistics(paramsData) {
    return axios.post(`/sale/workbench/wechatStatistics`, paramsData);
  },
  //提前撤场审核
  getWithdrawalPage(paramsData) {
    return axios.post(`/sale/project/withdrawal/withdrawalPage`, paramsData);
  },
  //提前撤场审核提交
  withdrawalCheck(paramsData) {
    return axios.post(`/sale/project/withdrawal/check`, paramsData);
  },
  //获取个人库存列表
  getGiftListForPersonal(paramsData) {
    return axios.get(`/sale/reserve/giftList`, { params: paramsData });
  },
  //库存信息转移个人库存
  reserveOutForPersonal(paramsData) {
    return axios.post(`/sale/reserve/reserveOut`, paramsData);
  },
  //个人库存记录
  reserveLogListForPersonal(paramsData) {
    return axios.get("/sale/reserve/reserveLog", { params: paramsData });
  },
  //个人库存遗失报备
  lostGiftForPersonal(paramsData) {
    return axios.post(`/sale/reserve/lost`, paramsData);
  },
  //获取待接收列表个人库存
  acceptedReserveForPersonal(paramsData) {
    return axios.get(`/sale/reserve/acceptedReserve`, { params: paramsData });
  },
  //项目库存接收列表个人库存
  addReceiveForPersonal(paramsData) {
    return axios.post(`/sale/reserve/receive`, paramsData);
  },
  //提交打分表草稿
  postScoreUpdate(paramsData) {
    return axios.post("/sale/scoring/web/update", paramsData);
  },
  //获取二面人员
  getSecondInterview(paramsData) {
    return axios.get("/sale/recruit/secondRecruitUserInfo", {
      params: paramsData
    });
  },
  //图片转base64
  base64Fomat(paramsData) {
    return axios.get(`https://api.mfzcw.com/upload/upload/PDFChangeBase64`, {
      params: paramsData
    });
  },
  //获取是否人脸识别标记
  getIsFaceClockIn(paramsData) {
    return axios.get(`/sale/faceClockOn`, { params: paramsData });
  },
  //获取统计排名
  getProjectSaleOrderData(paramsData) {
    return axios.get("/sale/workbench/selectSaleNoData", {
      params: paramsData
    });
  },
  //获取学习地图人员
  getStudentAndTeam(paramsData) {
    return axios.get(`/sale/staffProcessIni/studentAndTeam`, {
      params: paramsData
    });
  },
  //获取学习地图人员阶段
  getStaffProcessDetail(paramsData) {
    return axios.get(`/sale/staffProcessIni/staffProcessDetail`, {
      params: paramsData
    });
  },
  //获取学习地图流程模板
  getstaffProcessContent(paramsData) {
    return axios.get(`/sale/staffProcessIni/get`, { params: paramsData });
  },
  //学习地图流程进度保存
  staffProcessSave(paramsData) {
    return axios.post(`/sale/staffProcessIni/staffProcessSave`, paramsData);
  },
  //学习地图流程保存
  staffProcess(paramsData) {
    return axios.post(`/sale/staffProcessIni/staffProcess`, paramsData);
  },
  //学习地图听课本列表
  getBookPage(paramsData) {
    return axios.post(`/sale/textBook/bookPage`, paramsData);
  },
  //学习地图获考试试卷
  scoringDetailByStudyMap(paramsData) {
    return axios.get("/sale/staffProcessIni/questionBank", {
      params: paramsData
    });
  },
  //获取免登录
  getFreeLoginUrl(paramsData) {
    return axios.get("/sale/xrxs/getFreeLoginUrl", { params: paramsData });
  },
  //获取审批数量
  getApprovalNum(paramsData) {
    return axios.get("/sale/xrxs/getApprovalNum", { params: paramsData });
  },
  //每日一练，每周一练，每周一通列表
  getStaffQuestionPageList(paramsData) {
    return axios.post(`/sale/staffQuestion/questionPage`, paramsData);
  },
  //获取每日一练试卷
  getStaffQuestionDetail(paramsData) {
    return axios.get("/sale/staffQuestion/detail", { params: paramsData });
  },
  //每日一练，每周一练提交
  staffQuestionSave(paramsData) {
    return axios.post(`/sale/staffQuestion/save`, paramsData);
  },
  //获取车位品牌列表
  getCarBrandList(paramsData) {
    return axios.get("/sale/car/brand/list", { params: paramsData });
  },
  //获取徒弟列表
  getStaffQuestionStudent(paramsData) {
    return axios.get("/sale/staffQuestion/student", { params: paramsData });
  },
  //学院任务
  staffProcessIniTaskList(paramsData) {
    return axios.post(`/sale/staffProcessIni/taskPage`, paramsData);
  },
  //获取商学院代办数量
  // getSchoolTask(paramsData) {
  //     return axios.get(`/sale/workbench/schoolTask`, { params: paramsData });
  // },
  //商学院待处理数据统计
  getSchoolTodo(paramsData) {
    return axios.get(`/sale/school/pendingStatistical`, { params: paramsData });
  },

  //修改是否交完pk
  pkOver(paramsData) {
    return axios.post(`/sale/project/manage/pkOver`, paramsData);
  },
  //删除业主跟进
  deleteCusFollow(paramsData) {
    return axios.post(`/sale/customer/follow/delete`, paramsData);
  },
  //学习论坛
  getStudyForumQuestionPageList(paramsData) {
    return axios.post(`/sale/studyForum/questionPage`, paramsData);
  },
  //学习论坛添加题目
  studyForumSave(paramsData) {
    return axios.post(`/sale/studyForum/save`, paramsData);
  },
  //学习论坛题目详情
  studyForumDetail(paramsData) {
    return axios.get(`/sale/studyForum/detail`, { params: paramsData });
  },
  //学习论坛答案详情
  studyForumAnswerDetail(paramsData) {
    return axios.post(`/sale/studyForum/answerDetail`, paramsData);
  },
  //学习论坛答案提交
  studyForumSaveAnswer(paramsData) {
    return axios.post(`/sale/studyForum/saveAnswer`, paramsData);
  },
  //支援受邀列表new
  getBeInvitedList(paramsData) {
    return axios.get(`/sale/projectHelp/getBeInvitedList`, {
      params: paramsData
    });
  },
  //获取支援人员列表new
  projectHelpStaff(paramsData) {
    return axios.get(`/sale/projectHelp/staff`, { params: paramsData });
  },
  //获取项目支援项目详情new
  projectHelpDetail(paramsData) {
    return axios.get(`/sale/projectHelp/detail`, { params: paramsData });
  },
  //支援受邀列表记录new
  getInvitedList(paramsData) {
    return axios.get(`/sale/projectHelp/getInvitedList`, {
      params: paramsData
    });
  },
  //支援受邀列表记录详情new
  projectHelpDetailByGroupCode(paramsData) {
    return axios.get(`/sale/projectHelp/invitedDetail`, { params: paramsData });
  },
  //所有项目场次
  getAllSaleHistory(paramsData) {
    return axios.post(`/sale/workbench/saleHistory`, paramsData);
  },
  //支援项目待打卡数量
  projectHelpPendingCount(paramsData) {
    return axios.get(`/sale/projectHelp/pendingCount`, { params: paramsData });
  },
  //获取监控视频列表
  monitorPageList(paramsData) {
    return axios.post(`/sale/monitor/monitorPage`, paramsData);
  },
  //绑定设备
  monitorSave(paramsData) {
    return axios.post(`/sale/monitor/save`, paramsData);
  },
  //获取监控访问token
  monitorToken(paramsData) {
    return axios.get(`/sale/monitor/token`, { params: paramsData });
  },
  //获取监控人员列表
  getSelectStaff(paramsData) {
    return axios.get(`/sale/monitor/selectStaff`, { params: paramsData });
  },
  //业主优惠撤回
  withdraw(paramsData) {
    return axios.post(`/sale/customer/discount/withdraw`, paramsData);
  },
  //获取员工调动列表
  getTransferList(paramsData) {
    return axios.get(`/sale/personnelTransfer/get`, { params: paramsData });
  },
  //人员调动审核
  personTransferCheck(paramsData) {
    return axios.post(`/sale/personnelTransfer/check`, paramsData);
  },
  //发起人员调动
  startTransfer(paramsData) {
    return axios.post(`/sale/personnelTransfer/create`, paramsData);
  },
  //调动详情
  getDetails(paramsData) {
    return axios.get(`/sale/personnelTransfer/detail`, { params: paramsData });
  },
  //经理团队
  getManageLists(paramsData) {
    return axios.get(`/sale/personnelTransfer/managerTeam`, {
      params: paramsData
    });
  },
  //获取销售职员等级
  getSaleLevel(paramsData) {
    return axios.get(`/sale/personnelTransfer/saleRoleLevel`, {
      params: paramsData
    });
  },
  //新人带教
  newcomerMentoringList(paramsData) {
    return axios.post(`/sale/newcomerMentoring/list`, paramsData);
  },
  //新人带教新增
  newcomerMentoringSave(paramsData) {
    return axios.post(`/sale/newcomerMentoring/save`, paramsData);
  },
  //获取新人带教详情
  newcomerMentoringDetail(paramsData) {
    return axios.get(`/sale/newcomerMentoring/detail`, { params: paramsData });
  },
  //新人带教作废
  newcomerMentoringCancel(paramsData) {
    return axios.post(`/sale/newcomerMentoring/cancel`, paramsData);
  },
  //获取新人带教作废流程详情
  getNewcomerMentoringProcessDetail(paramsData) {
    return axios.get(`/sale/newcomerMentoring/newcomerMentoringProcessDetail`, {
      params: paramsData
    });
  },
  //新人带教流程保存
  newcomerMentoringProcessSave(paramsData) {
    return axios.post(
      `/sale/newcomerMentoring/newcomerMentoringProcess`,
      paramsData
    );
  },
  //新人带教流程提交
  newcomerMentoringSubmit(paramsData) {
    return axios.post(`/sale/newcomerMentoring/submit`, paramsData);
  },
  //话术收集列表
  verbalTrickSaleList(paramsData) {
    return axios.post(`/sale/project/verbalTrickSale/list`, paramsData);
  },
  //新增收集话术
  verbalTrickSaleAdd(paramsData) {
    return axios.post(`/sale/project/verbalTrickSale/add`, paramsData);
  },
  //新增收集话术查阅
  verbalTrickSaleRead(paramsData) {
    return axios.post(`/sale/project/verbalTrickSale/read`, paramsData);
  },
  //话术采纳
  verbalTrickSaleAdopt(paramsData) {
    return axios.post(`/sale/project/verbalTrickSale/adopt`, paramsData);
  },
  //匿名信提交
  submitAnonymousLetter(paramsData) {
    return axios.post(`/sale/anonymousLetter/create`, paramsData);
  },
  //匿名信列表
  getAnonymousLetter(paramsData) {
    return axios.get(`/sale/anonymousLetter/get`, { params: paramsData });
  },
  //待处理匿名信数量
  getAnonymousNumber(paramsData) {
    return axios.get(`/sale/anonymousLetter/pendingCount`, {
      params: paramsData
    });
  },
  //回复匿名信数量
  getReplyAnonymousNumber(paramsData) {
    return axios.get(`/sale/anonymousLetter/replyCount`, {
      params: paramsData
    });
  },
  //匿名信回复提交
  submitAnonymousApply(paramsData) {
    return axios.post(`/sale/anonymousLetter/reply`, paramsData);
  },
  //匿名信回复列表
  getAnonymousLetterApplyList(paramsData) {
    return axios.get(`/sale/anonymousLetter/replyList`, { params: paramsData });
  },
  //设置匿名信为已读
  setHasReadAnonymousLetter(paramsData) {
    return axios.post(`sale/anonymousLetter/setReadState`, paramsData);
  },
  //获取销售员工
  managerSaleStaff(paramsData) {
    return axios.get(`/sale/manager/managerSaleStaff`, { params: paramsData });
  },
  //三方安装列表
  merchantOrderList(paramsData) {
    return axios.post(`/sale/merchant/order/list`, paramsData);
  },
  //商户列表
  merchantPageList(paramsData) {
    return axios.post(`/sale/merchant/merchantPage`, paramsData);
  },
  //获取商户安装类型
  reimbursementTypeList(paramsData) {
    return axios.get(`/sale/reimbursement/typeList`, { params: paramsData });
  },
  //获取安装类型费用
  merchantFeePage(paramsData) {
    return axios.post(`/sale/merchantFee/merchantFeePage`, paramsData);
  },
  //现金收款统计
  cashStatisticData(paramsData) {
    return axios.get(`/sale/cash/staffStatistics`, { params: paramsData });
  },
  //新增三方安装申请
  merchantOrderAdd(paramsData) {
    return axios.post(`/sale/merchant/order/add`, paramsData);
  },
  //新增三方安装申请详情
  merchantDetail(paramsData) {
    return axios.get(`/sale/merchant/order/detail`, { params: paramsData });
  },
  //审核三方安装申请
  merchantAudit(paramsData) {
    return axios.post(`/sale/merchant/order/audit`, paramsData);
  },
  //编辑三方安装申请
  merchantOrderUpdate(paramsData) {
    return axios.post(`/sale/merchant/order/update`, paramsData);
  },
  //三方安装流程
  merchantProcess(paramsData) {
    return axios.get(`/sale/merchant/order/process`, { params: paramsData });
  },
  //三方安装车位列表（安装情况）
  feeParkList(paramsData) {
    return axios.get(`/sale/merchant/order/feeParkList`, {
      params: paramsData
    });
  },
  //三方安装车位待处理条数
  merchantPendingCount(paramsData) {
    return axios.get(`/sale/merchant/order/pendingCount`, {
      params: paramsData
    });
  },
  //三方安装结算审核列表
  merchantSettlementList(paramsData) {
    return axios.post(`/sale/merchant/order/settlement/list`, paramsData);
  },
  //三方安装结算详情
  merchantSettlementDetail(paramsData) {
    return axios.get(`/sale/merchant/order/settlement/detail`, {
      params: paramsData
    });
  },
  //三方安装结算表审核
  merchantSettlementAudit(paramsData) {
    return axios.post(`/sale/merchant/order/settlement/audit`, paramsData);
  },
  //三方安装流程新
  merchantProcessNew(paramsData) {
    return axios.get(`/sale/merchant/order/settlement/process`, {
      params: paramsData
    });
  },
  //三方安装车位审核待处理条数
  merchantPendingAuditCount(paramsData) {
    return axios.get(`/sale/merchant/order/settlement/pendingCount`, {
      params: paramsData
    });
  },
  //确认登录
  authLogin(paramsData) {
    return axios.post(`/sale/authLogin`, paramsData);
  },
  //未转交列表
  noTransferList(paramsData) {
    return axios.post(`/sale/informationFee/notTransferList`, paramsData);
  },
  //未转交列表v2
  noTransferListV2(paramsData) {
    return axios.post(`/sale/cash/v2/notTransferList`, paramsData);
  },
  //转交
  transferV2(paramsData) {
    return axios.post(`/sale/cash/v2/transfer`, paramsData);
  },
  //待接收现金列表
  pendingTransferList(paramsData) {
    return axios.post(`/sale/cash/v2/pendingList`, paramsData);
  },
  //接收现金
  cashReceive(paramsData) {
    return axios.post(`/sale/cash/v2/receive`, paramsData);
  },
  //转交现金
  cashPoolReceive(paramsData) {
    return axios.post(`/sale/cash/v2/cashPoolReceive`, paramsData);
  },
  //转交列表
  cashPoolTransmitList(paramsData) {
    return axios.post(`/sale/cash/v2/cashPoolTransmitList`, paramsData);
  },
  //现金明细
  cashDetailV2(paramsData) {
    return axios.get(`/sale/cash/v2/detail`, { params: paramsData });
  },
  //当前现金池数据
  cashPoolCurrentInfo(paramsData) {
    return axios.get(`/sale/cash/v2/cashPoolCurrentInfo`, {
      params: paramsData
    });
  },
  //获取现金接收职位及数据
  receiveRoleInfo2(paramsData) {
    return axios.get(`/sale/cash/v2/receiveRoleInfo`, { params: paramsData });
  },
  //经理转交
  cashPoolTransfer(paramsData) {
    return axios.post(`/sale/cash/v2/cashPoolTransfer`, paramsData);
  },
  //现金池转交记录
  cashPoolTransferHistoryList(paramsData) {
    return axios.get(`/sale/cash/v2/cashPoolTransferHistoryList`, {
      params: paramsData
    });
  },
  //待接收现金列表
  cashPoolPendingList(paramsData) {
    return axios.post(`/sale/cash/v2/cashPoolPendingList`, paramsData);
  },
  //转交明细
  infoFeeTransferDetail(paramsData) {
    return axios.get(`/sale/informationFee/detail`, { params: paramsData });
  },
  //银行账户余额查询
  queryBankAccountBalance(paramsData) {
    return axios.get(`/sale/bankAccountBalance/get`, { params: paramsData });
  },
  //获取本项目pos机信息
  collectionAccountPostList(paramsData) {
    return axios.get(`/sale/collectionAccount/postList`, {
      params: paramsData
    });
  },
  //标记服务协议无需提交
  setNotNeedTransfer(paramsData) {
    return axios.post(`/sale/serviceAgreement/setNotNeedTransfer`, paramsData);
  },
  //获取推盘信息
  getManageInfer(paramsData) {
    return axios.get(`/sale/project/manage/infer`, { params: paramsData });
  },
  //获取推盘信息
  getMerchantFeeFloorPaint(paramsData) {
    return axios.get(`/sale/merchantFee/floorPaint`, { params: paramsData });
  },
  //获取车位优惠信息
  selectParkManageFee(paramsData) {
    return axios.get(`/sale/buy/selectParkManageFee`, { params: paramsData });
  },
  //经理送礼撤回
  withdrawGift(paramsData) {
    return axios.post(`/sale/project/manage/withdrawGift`, paramsData);
  },
  //朋友圈素材列表
  friendCircleMaterialList(paramsData) {
    return axios.get(`/sale/friendsCircle/get`, { params: paramsData });
  },
  //上传朋友圈素材
  uploadFriendCircle(paramsData) {
    return axios.post(`/sale/friendsCircle/upload`, paramsData);
  },
  //删除盆友圈素材
  deleteFriendCircleMaterial(paramsData) {
    return axios.post(`/sale/friendsCircle/del`, paramsData);
  },
  //我的素材上传记录
  uploadFriendCircleHistory(paramsData) {
    return axios.get(`/sale/friendsCircle/uploadHistory`, {
      params: paramsData
    });
  },
  //数据汇总
  projectDeveloperReturnedMoney(paramsData) {
    return axios.get(`/sale/workbench/projectDeveloperReturnedMoney`, {
      params: paramsData
    });
  },
  //资料费退款申请
  informationRefundApply(paramsData) {
    return axios.post(`/sale/informationFeeRefund/refundApply`, paramsData);
  },
  //获取策略数据
  policeLibList(paramsData) {
    return axios.post(`/sale/policeLib/list`, paramsData);
  },
  //获取话术详情
  verbalTrickDetail(paramsData) {
    return axios.get(`/sale/project/verbalTrick/detail`, {
      params: paramsData
    });
  },
  //获取广告数据
  advertLibList(paramsData) {
    return axios.post(`/sale/advertLib/list`, paramsData);
  },
  //获取听录音数量
  getSoundNum(paramsData) {
    return axios.get(`/sale/project/manage/soundNum`, { params: paramsData });
  },
  //获取财务移交借用
  getReceiptBorrow(paramsData) {
    return axios.get(`/sale/project/manage/receiptBorrow`, {
      params: paramsData
    });
  },
  //开关面板修改
  openClose(paramsData) {
    return axios.post(`/sale/project/manage/openClose`, paramsData);
  },
  //开关面板详情
  openCloseDetail(paramsData) {
    return axios.get(`/sale/project/manage/openCloseDetail`, {
      params: paramsData
    });
  },
  //获取后佣收弹窗
  getPressMoneyAlert(paramsData) {
    return axios.post(`/sale/pressMoney/pressMoneyAlert`, paramsData);
  },
  //设置忽略获取后佣收弹窗
  savePressMoneyAlert(paramsData) {
    return axios.post(`/sale/pressMoney/savePressMoneyAlert`, paramsData);
  },
  //获取遗失/报损流程
  getLostOrReportedLoss(paramsData) {
    return axios.post(`/sale/reserve/lostProgress/list`, paramsData);
  },
  //遗失报损详情
  getLostProgressDetails(paramsData) {
    return axios.get(`/sale/reserve/lostProgress/detail`, {
      params: paramsData
    });
  },
  //审核遗失/报损
  checkLostApply(paramsData) {
    return axios.post(`/sale/reserve/lostProgress/check`, paramsData);
  },
  //批量报废
  moreBatchScrap(paramsData) {
    return axios.post(`/sale/park/batchScrap`, paramsData);
  },
  //批量预选
  moreBatchPreselection(paramsData) {
    return axios.post(`/sale/park/batchPreselection`, paramsData);
  },
  //批量假车牌
  moreBatchStickFakeLicensePlate(paramsData) {
    return axios.post(`/sale/park/batchStickFakeLicensePlate`, paramsData);
  },
  //商品领用列表
  getProductReserveList(paramsData) {
    return axios.post(`/sale/productReserve/list`, paramsData);
  },
  //商品领用保存
  productReserveSave(paramsData) {
    return axios.post(`/sale/productReserve/save`, paramsData);
  },
  //商品领用详情
  productReserveDetail(paramsData) {
    return axios.get(`/sale/productReserve/detail`, { params: paramsData });
  },
  //OA模块待办数量
  pendingOaNum(paramsData) {
    return axios.get(`/sale/workbench/pendingOaNum`, { params: paramsData });
  },
  //微信统计获取B级以上数据
  abCustomerWechatStatistics(paramsData) {
    return axios.post(`/sale/workbench/abCustomerWechatStatistics`, paramsData);
  },
  //客情推荐费详情
  customerMaintenanceRecommendDetail(paramsData) {
    return axios.get(`/sale/customerMaintenanceRecommend/detail`, {
      params: paramsData
    });
  },
  //客情推荐费申请
  customerMaintenanceRecommendApply(paramsData) {
    return axios.post(`/sale/customerMaintenanceRecommend/apply`, paramsData);
  },
  //客情推荐费审核列表
  customerMaintenanceRecommendList(paramsData) {
    return axios.get(`/sale/customerMaintenanceRecommend/get`, {
      params: paramsData
    });
  },
  //客情推荐费审核
  customerMaintenanceRecommendAudit(paramsData) {
    return axios.post(`/sale/customerMaintenanceRecommend/check`, paramsData);
  },
  //商品领用作废
  productReserveDel(paramsData) {
    return axios.post(`/sale/productReserve/del`, paramsData);
  },
  //获取历史客情推荐费信息
  reimbursementSignPrice(paramsData) {
    return axios.get(`/sale/reimbursement/signPrice`, { params: paramsData });
  },
  //中转列表
  reserveTransitGet(paramsData) {
    return axios.get(`/sale/reserveTransit/get`, { params: paramsData });
  },
  //中转申请
  reserveTransitApply(paramsData) {
    return axios.post(`/sale/reserveTransit/apply`, paramsData);
  },
  //获取渠道佣金列表
  queryCustomerServiceFee(paramsData) {
    return axios.post(`/sale/serviceFee/serviceFeeList`, paramsData);
  },
  //现金池转交-流转
  cashPoolTransferTo(paramsData) {
    return axios.post(`/sale/cash/v2/cashPoolTransferTo`, paramsData);
  },
  //现金收款-转交记录新
  transferHistoryListV2(paramsData) {
    return axios.post(`/sale/cash/v2/transferHistoryList`, paramsData);
  },
  //现金收款-转交记录
  cashDetailV2(paramsData) {
    return axios.get(`/sale/cash/v2/detail`, { params: paramsData });
  },
  //作废催收信息(催收id)
  delePressForMoneyTimeRecords(paramsData) {
    return axios.post("/sale/pressMoney/del", paramsData);
  },
  //政委标记服务费
  serviceFlag(paramsData) {
    return axios.post("/sale/buy/serviceFlag", paramsData);
  },
  //获取大区数据
  queryZoneData(paramsData) {
    return axios.get(`/sale/zone/list`, { params: paramsData });
  },
  //修改项目库存类型
  reserveTypeChange(paramsData) {
    return axios.post("/sale/project/manage/reserveTypeChange", paramsData);
  },
  //获取所有公司
  getAllCompany(paramsData) {
    return axios.get("/sale/workbench/getAllCompany", { params: paramsData });
  },
  //我方数据汇总保存
  dataSumarySave(paramsData) {
    return axios.post(`/sale/project/receiveTotal/save`, paramsData);
  },
  //我方数据详情
  dataSumaryDetail(paramsData) {
    return axios.get(`/sale/project/receiveTotal/detail`, {
      params: paramsData
    });
  },
  //公司移交库存
  reserveOutCompany(paramsData) {
    return axios.post(`/sale/reserve/reserveOutCompany`, paramsData);
  },
  //拓展PK列表
  developerPkList(paramsData) {
    return axios.post(`/sale/developerPk/list`, paramsData);
  },
  //项目库存闲置设置
  reserveUnused(paramsData) {
    return axios.post(`/sale/project/manage/reserveUnused`, paramsData);
  },
  //项目库存闲置列表
  unusedReserveList(paramsData) {
    return axios.post(`/sale/reserveTransit/unusedReserveList`, paramsData);
  },
  //项目中转仓列表
  transitReserveList(paramsData) {
    return axios.post(`/sale/reserveTransit/transitReserveList`, paramsData);
  },
  //获取销售流程数据
  saleProcessDetail(paramsData) {
    return axios.get(`/sale/saleProcess/saleProcessDetail`, {
      params: paramsData
    });
  },
  //销售流程保存
  saleProcessForsaleSave(paramsData) {
    return axios.post(`/sale/saleProcess/save`, paramsData);
  },
  //销售流程节点保存
  saleProcessForsaleNext(paramsData) {
    return axios.post(`/sale/saleProcess/next`, paramsData);
  },
  //中转标记已查阅
  reserveTransitCopyCheck(paramsData) {
    return axios.post(`/sale/reserveTransit/copyCheck`, paramsData);
  },
  //获取中转仓保管人员信息
  reserveTransitQueryCustodian(paramsData) {
    return axios.post(`/sale/reserveTransit/queryCustodian`, paramsData);
  },
  //商学院每日一练统计
  businessStatistic(paramsData) {
    return axios.post("/sale/staffQuestion/statistics", paramsData);
  },
  //获取闲置商品
  getUnusedReserve(paramsData) {
    return axios.get(`/sale/purchase/getUnusedReserve`, { params: paramsData });
  },
  //收据预计归还列表
  receiptExpectReturn(paramsData) {
    return axios.get(`/sale/borrow/receiptExpectReturn`, {
      params: paramsData
    });
  },
  //项目流程-收据预计归还保存
  receiptExpectReturnSave(paramsData) {
    return axios.post(`/sale/borrow/receiptExpectReturnSave`, paramsData);
  },
  //待办事项参会处理
  completeTodo(paramsData) {
    return axios.post(`/sale/pending/toDoList/completeTodo`, paramsData);
  },
  //获取紧急事务
  toDoListGet(paramsData) {
    return axios.get(`/sale/emergent/toDoList/get`, { params: paramsData });
  },
  //完成紧急事务
  completeTodoImportant(paramsData) {
    return axios.post(`/sale/emergent/toDoList/completeTodo`, paramsData);
  },
  //复盘项目列表
  replayList(paramsData) {
    return axios.post(`/sale/project/inferAndReplay/replayList`, paramsData);
  },
  //获取复盘信息
  inferDetail(paramsData) {
    return axios.get(`/sale/project/inferAndReplay/replayDetail`, {
      params: paramsData
    });
  },
  //获取复盘信息
  projectHisInfo(paramsData) {
    return axios.get(`/sale/project/inferAndReplay/projectHisInfo`, {
      params: paramsData
    });
  },
  //获取推盘信息
  replayDetail(paramsData) {
    return axios.get(`/sale/project/inferAndReplay/inferDetail`, {
      params: paramsData
    });
  },
  //复盘项目列表
  pressMoneyEdit(paramsData) {
    return axios.post(`/sale/pressMoney/edit`, paramsData);
  },
  //项目巡场列表
  getProjectPatrol(paramsData) {
    return axios.post(`/sale/project/patrol/patrolPage`, paramsData);
  },
  //巡场保存
  savePatrolInfo(paramsData) {
    return axios.post(`/sale/project/patrol/save`, paramsData);
  },
  //巡场记录
  getPatrolRecord(paramsData) {
    return axios.get(`/sale/project/patrol/patrolList`, { params: paramsData });
  },
  //广告申请列表
  getAdvertisingApply(paramsData) {
    return axios.post(
      `/sale/advertisementApply/advertisementApplyList`,
      paramsData
    );
  },
  //广告申请详情
  getAdvertisingDetail(paramsData) {
    return axios.get(`/sale/advertisementApply/detail`, { params: paramsData });
  },
  //广告申请审核
  advertisingReview(paramsData) {
    return axios.post(`/sale/advertisementApply/checkState`, paramsData);
  },
  //提交广告申请
  submitAdvertisingApply(paramsData) {
    return axios.post(`/sale/advertisementApply/save`, paramsData);
  },
  //广告类型管理列表
  getAdvertisingType(paramsData) {
    return axios.post(`/sale/advertisement/list`, paramsData);
  }, //获取项目的预算广告费用
  getExpectedPrice(paramsData) {
    return axios.get(`/sale/advertisementApply/expectedPrice`, {
      params: paramsData
    });
  },
  //提交日志点评
  saveDailyLogComment(paramsData) {
    return axios.post(`/sale/my/daily/comment`, paramsData);
  },
  //带看问卷
  writeInvestigate(paramsData) {
    return axios.post(`/sale/customer/writeInvestigate`, paramsData);
  },
  //带看问卷详情
  investigateDetail(paramsData) {
    return axios.get(`/sale/customer/investigateDetail`, {
      params: paramsData
    });
  },
  //获取wifi标识
  getWifiBssid(paramsData) {
    return axios.get(`/sale/clockOn/wifiBssid`, { params: paramsData });
  },
  //保存面试个人信息
  userInfoSave(paramsData) {
    return axios.post(`/sale/recruit/userInfoSave`, paramsData);
  },
  //保存积分
  addIntegral(paramsData) {
    return axios.post(`/sale/integralReporting/save`, paramsData);
  },
  //综合积分提报列表
  interalList(paramsData) {
    return axios.get(`/sale/integralReporting/list`, { params: paramsData });
  },
  //综合积分提报审核
  checkInteralData(paramsData) {
    return axios.post(`/sale/integralReporting/check`, paramsData);
  },
  //员工安装列表
  staffInstallList(paramsData) {
    return axios.post(`/sale/staffInstall/staffInstallList`, paramsData);
  },
  //获取员工安装车位列表
  getSelfInstallParkList(paramsData) {
    return axios.post(`/sale/staffInstall/parkList`, paramsData);
  },
  //员工安装车位
  staffSelfInstallSave(paramsData) {
    return axios.post(`/sale/staffInstall/save`, paramsData);
  },
  //获取员工安装车位详情
  staffInstallDetail(paramsData) {
    return axios.get(`/sale/staffInstall/detail`, { params: paramsData });
  },
  //员工安装审核
  staffInstallCheckState(paramsData) {
    return axios.post(`/sale/staffInstall/checkState`, paramsData);
  },
  //取消红点
  cancelRedDot(paramsData) {
    return axios.post(`/sale/integralReporting/cancelRed`, paramsData);
  },
  //撤回签约
  signWithdraw(paramsData) {
    return axios.post(`/sale/buy/signWithdraw`, paramsData);
  },
  //论坛点赞
  studyForumAddPraise(paramsData) {
    return axios.post(`/sale/studyForum/addPraise`, paramsData);
  },
  //论坛点赞
  manageDisTask(paramsData) {
    return axios.post(`/sale/project/manage/disTask`, paramsData);
  },
  //运营项目列表详情
  projectListDetail(paramsData) {
    return axios.get(`/sale/operation/projectListDetail`, {
      params: paramsData
    });
  },
  //运营项目列表
  projectManageList(paramsData) {
    return axios.get(`/sale/operation/projectList`, { params: paramsData });
  },
  //运营销量列表详情
  saleMangerList(paramsData) {
    return axios.get(`/sale/operation/saleList`, { params: paramsData });
  },
  //运营销量列表项目销售情况
  saleCalendar(paramsData) {
    return axios.get(`/sale/operation/calendar`, { params: paramsData });
  },
  //商品领用审核
  productReserveCheck(paramsData) {
    return axios.post(`/sale/productReserve/check`, paramsData);
  },
  //是否有0的催收
  pressMoneyHavaZero(paramsData) {
    return axios.get(`/sale/pressMoney/havaZero`, { params: paramsData });
  },
  //获取所有部门
  getDeptList(paramsData) {
    return axios.get(`/sale/my/staff/deptList`, { params: paramsData });
  },
  //保存师傅评价
  saveTeacherEvaluate(paramsData) {
    return axios.post(`/sale/my/staff/saveTeacherEvaluate`, paramsData);
  },
  //查询师傅评价
  getTeacherEvaluate(paramsData) {
    return axios.get(`/sale/my/staff/teacherEvaluateList`, {
      params: paramsData
    });
  },
  //pos机订单列表
  buyPosList(paramsData) {
    return axios.post(`/sale/buy/list`, paramsData);
  },
  //保存邀请函
  saveInvitation(paramsData) {
    return axios.post(`/sale/project/manage/saveInvitation`, paramsData);
  },
  //获取邀请函
  getInvitation(paramsData) {
    return axios.get(`/sale/project/manage/invitation`, { params: paramsData });
  },
  //获取项目关联预打款数据
  advancePaymentInfo(paramsData) {
    return axios.get(`/sale/paymentApplication/cancel`, { params: paramsData });
  },
  //用章申请
  useSealApply(paramsData) {
    return axios.post(`/sale/borrow/useSealApply`, paramsData);
  },
  //用章申请详情
  useSealApplyDetail(paramsData) {
    return axios.get(`/sale/borrow/useSealApplyDetail`, { params: paramsData });
  },
  //用章申请审核
  useSealApplyCheck(paramsData) {
    return axios.post(`/sale/borrow/useSealApplyCheck`, paramsData);
  },
  //修改周计划
  weeklyPlanEdit(paramsData) {
    return axios.post(`/sale/weeklyPlan/edit`, paramsData);
  },
  //最佳贡献奖
  bestContribution(paramsData) {
    return axios.get(`/sale/project/bestcontribution/bestContribution`, {
      params: paramsData
    });
  },
  //最佳贡献奖评选开启
  openBestContribution(paramsData) {
    return axios.post(`/sale/project/bestcontribution/open`, paramsData);
  },
  //最佳贡献奖人员选择
  getBestcontributionTeam(paramsData) {
    return axios.get(`/sale/project/bestcontribution/team`, {
      params: paramsData
    });
  },
  //最佳贡献奖保存
  saveBestContribution(paramsData) {
    return axios.post(`/sale/project/bestcontribution/save`, paramsData);
  },
  //最佳贡献奖详情
  bestContributionDetail(paramsData) {
    return axios.get(`/sale/project/bestcontribution/bestContributionDetail`, {
      params: paramsData
    });
  },
  //新增AI评论
  AiComment(paramsData) {
    return axios.post(
      base.phoneUrl + `/speed/ai/comment/AiComment`,
      paramsData
    );
  },
  //pos机订单
  lklList(paramsData) {
    return axios.post(`/sale/lkl/list`, paramsData);
  },
  //pos机统计
  sumPrice(paramsData) {
    return axios.get(`/sale/lkl/sumPrice`, { params: paramsData });
  },
  //pos机订单详情
  lklDetail(paramsData) {
    return axios.get(`/sale/lkl/detail`, { params: paramsData });
  },
  //pos机订单更换信息
  lklUpdate(paramsData) {
    return axios.post(`/sale/lkl/update`, paramsData);
  },
  //线下课堂签到
  offlineSign(paramsData) {
    return axios.post(`/sale/offline/sign`, paramsData);
  },
  //线下课堂评分
  offlineEvaluate(paramsData) {
    return axios.post(`/sale/offline/evaluate`, paramsData);
  },
  //线下课堂评分详情
  evaluateDetail(paramsData) {
    return axios.get(`/sale/offline/evaluateDetail`, { params: paramsData });
  },
  //勋章查询
  queryMedal(paramsData) {
    return axios.get(`/sale/my/staff/medal`, { params: paramsData });
  },
  //成就榜单查询
  queryStaffMedalData(paramsData) {
    return axios.get(`/sale/my/staff/medalTopList`, { params: paramsData });
  },
  //设置主推
  batchSetMainPark(paramsData) {
    return axios.post(`/sale/park/batchSetMainPark`, paramsData);
  },
  //获取pos机核对信息
  managePosCheck(paramsData) {
    return axios.get(`/sale/project/manage/posCheck`, { params: paramsData });
  },
  //车位注水一键还原
  parkReset(paramsData) {
    return axios.post(`/sale/park/reset`, paramsData);
  },
  //录音推荐
  callRecommend(paramsData) {
    return axios.post(`/sale/call/recommend`, paramsData);
  },
  //优质录音列表
  recordingGood(paramsData) {
    return axios.post(`/sale/call/recording`, paramsData);
  },
  //优质录音设置奖
  setWin(paramsData) {
    return axios.post(`/sale/call/setWin`, paramsData);
  },
  //获取安装次数详情
  installDetail(paramsData) {
    return axios.get(`/sale/staffInstall/installDetail`, {
      params: paramsData
    });
  },
  //小蜜蜂AI聊天人员列表
  staffChatChatList(paramsData) {
    return axios.post(base.phoneUrl + `/speed/staffChat/chatList`, paramsData);
  },
  //小蜜蜂AI新增聊天
  staffChatAdd(paramsData) {
    return axios.post(base.phoneUrl + `/speed/staffChat/add`, paramsData);
  },
  //小蜜蜂AI聊天记录
  staffChatChatLog(paramsData) {
    return axios.post(base.phoneUrl + `/speed/staffChat/chatLog`, paramsData);
  },
  //个人固资盘点
  personalFixedAssetsList(paramsData) {
    return axios.get(`/sale/staffReserve/staffReserveList`, {
      params: paramsData
    });
  },
  //个人固资盘点编辑
  editPersonalFixedAssets(paramsData) {
    return axios.post(`/sale/staffReserve/edit`, paramsData);
  },
  //车位设置假价格
  parkBatchSetPrice(paramsData) {
    return axios.post(`/sale/park/batchSetPrice`, paramsData);
  },
  //车位设置假价格一键还原
  parkResetPrice(paramsData) {
    return axios.post(`/sale/park/resetPrice`, paramsData);
  },
  //产值PK
  companyPkAppList(paramsData) {
    return axios.post(`/sale/companyPk/appList`, paramsData);
  },
  //分公司项目审核
  companyCheckList(paramsData) {
    return axios.post(`/sale/workbench/companyCheckList`, paramsData);
  },
  //分公司项目审核详情
  companyCheckDetail(paramsData) {
    return axios.get(`/sale/workbench/companyCheckDetail`, {
      params: paramsData
    });
  },
  //分公司项目审核
  companyCheck(paramsData) {
    return axios.post(`/sale/workbench/companyCheck`, paramsData);
  },
  //获取历史评估
  getHistoryReplayList(paramsData) {
    return axios.get(`/sale/project/inferAndReplay/historyReplayList`, {
      params: paramsData
    });
  },
  //获取签约人
  getSignStaffList(paramsData) {
    return axios.get(`/sale/manager/signStaff`, { params: paramsData });
  },
  buyParkHistory(paramsData) {
    return axios.get(`/sale/customer/buyParkHistoryList`, {
      params: paramsData
    });
  },
  buyParkHistoryEdit(paramsData) {
    return axios.post(`/sale/customer/buyParkHistoryEdit`, paramsData);
  },
  //获取撤场审核状态
  getWithdrawalCheckState(paramsData) {
    return axios.get(`/sale/project/withdrawal/withdrawalCheckState`, {
      params: paramsData
    });
  },
  //经理查阅接口
  isRead(paramsData) {
    return axios.post(`/sale/customer/follow/read`, paramsData);
  },
  //问卷调查详情
  questionDetail(paramsData) {
    return axios.post(`/sale/question/questionListDetail`, paramsData);
  },
  //蜂族共学列表
  getFzStudyList(paramsData) {
    return axios.post(`/sale/fzStudy/fzStudyList`, paramsData);
  },
  //蜂族共学详情列表
  getFzStudyDetailList(paramsData) {
    return axios.post(`/sale/fzStudy/fzStudyDetailList`, paramsData);
  },
  //蜂族共学提交作业
  saveContent(paramsData) {
    return axios.post(`/sale/fzStudy/saveContent`, paramsData);
  },
  //蜂族共学提交作业点赞
  addPraiseFzStudy(paramsData) {
    return axios.post(`/sale/fzStudy/addPraise`, paramsData);
  },
  //撤回宣传送礼
  widthdrawGift(paramsData) {
    return axios.post(`/sale/customer/giftWithdraw`, paramsData);
  },
  //线下课堂请假
  trianningLeave(paramsData) {
    return axios.post(`/sale/offline/leave`, paramsData);
  },
  //退款列表
  buyRefundList(paramsData) {
    return axios.post(`/sale/buy/refundList`, paramsData);
  },
  //会议管理
  getMeetingManageData(paramsData) {
    return axios.get(`/sale/meeting/get`, { params: paramsData });
  },
  //推荐人列表
  recommendList(paramsData) {
    return axios.post(`/sale/recommend/list`, paramsData);
  },
  //推荐人新增
  recommendSave(paramsData) {
    return axios.post(`/sale/recommend/save`, paramsData);
  },
  //推荐人删除
  recommendDelete(paramsData) {
    return axios.post(`/sale/recommend/del`, paramsData);
  },
  //推荐人推荐费列表
  recommendSettlementList(paramsData) {
    return axios.post(`/sale/recommend/recommendSettlementList`, paramsData);
  },
  //扫码 选择招聘岗位
  recruitRole(paramsData) {
    return axios.get(`/sale/recruit/recruitRole`, { params: paramsData });
  },
  //查看薪酬验证登录密码
  passVilify(paramsData) {
    return axios.post(`/sale/passVilify`, paramsData);
  },
  //获取物品类型
  getGoodsType(paramsData) {
    return axios.get(`/sale/borrow/getType`, { params: paramsData });
  },
  //获取拓展端甲方复盘会议内容
  reviewMeetingFeedback(paramsData) {
    return axios.get(`/sale/project/manage/reviewMeetingFeedback`, {
      params: paramsData
    });
  },
  //现金转交上传转账凭证
  uploadTransferVoucherPic(paramsData) {
    return axios.post(`/sale/cash/v2/uploadTransferVoucherPic`, paramsData);
  },
  //面试列表
  recruitList(paramsData) {
    return axios.get(`/sale/recruit/toDoList`, { params: paramsData });
  },
  //面试填写保存（打分表）
  recruitScore(paramsData) {
    return axios.post(`/sale/recruit/web/interview`, paramsData);
  },
  getParkInfo(paramsData) {
    return axios.get(`/sale/park/parkViewList`, { params: paramsData });
  },
  getParkViewDetail(paramsData) {
    return axios.get(`/sale/park/parkViewDetail`, { params: paramsData });
  },
  //合同PK
  contractPkList(paramsData) {
    return axios.post(`/sale/contractPk/list`, paramsData);
  },
  getXiaodingStatistic(paramsData) {
    return axios.post(`/sale/customer/letterList`, paramsData);
  },
  getXiaodingStatisticTotalNum(paramsData) {
    return axios.post(`/sale/customer/letterStat`, paramsData);
  },
  //呼叫中心-呼叫列表
  getCallCenterList(paramsData) {
    return axios.get(`/sale/developer/query/call/list`, { params: paramsData });
  },
  //呼叫明细列表
  getCallListData(paramsData) {
    return axios.get(`/sale/developer/query/list`, { params: paramsData });
  },
  //开发商下的资源列表
  getCallListByResource(paramsData) {
    return axios.get(`/sale/developer/query/resourceListByQueryId`, {
      params: paramsData
    });
  },
  //呼叫详情
  queryCallDetails(paramsData) {
    return axios.get(`/sale/developer/query/call/detail`, {
      params: paramsData
    });
  },
  //保存呼叫结果
  saveCallResult(paramsData) {
    return axios.post(`/sale/developer/query/call/saveResult`, paramsData);
  },
  //小程序发放礼品
  minSysGiftLog(paramsData) {
    return axios.post(`/sale/wx/customer/giftLog`, paramsData);
  },
  //微信小程序礼品核销
  customerWriteOff(paramsData) {
    return axios.post(`/sale/wx/customer/writeOff`, paramsData);
  },
  //获取卷二维码详情
  customerDetailByTW(paramsData) {
    return axios.get(`/sale/wx/customer/detail`, { params: paramsData });
  },
  //获取核销次数
  selectByCustomerId(paramsData) {
    return axios.get(`/sale/wx/customer/selectByCustomerId`, {
      params: paramsData
    });
  },
  //获取工单列表
  getWorkOrder(paramsData) {
    return axios.get(`/sale/workOrder/mySendList`, { params: paramsData });
  },
  //发起工单
  addWorkOrder(paramsData) {
    return axios.post(`/sale/workOrder/launch`, paramsData);
  },
  //工单详情
  workOrderDetail(paramsData) {
    return axios.get(`/sale/workOrder/detail`, { params: paramsData });
  },
  //鱼骨保存
  fishboneSave(paramsData) {
    return axios.post("/sale/project/fishbone/save", paramsData);
  },
  //预测销量获取详情
  selectFishboneByForecastId(paramsData) {
    return axios.get(`/sale/project/fishbone/forecastDetail`, {
      params: paramsData
    });
  },
  //获取挞定列表
  selectTDList(paramsData) {
    return axios.get(`/sale/buy/selectTDList`, { params: paramsData });
  },
  //获取b岗跟进经理
  getBManager(paramsData) {
    return axios.get(`/sale/customer/follow/getBManager`, {
      params: paramsData
    });
  },
  //订单列表
  wxOrderList(paramsData) {
    return axios.post("/sale/wx/customer/orderList", paramsData);
  },
  //定金转换
  transferDeposit(paramsData) {
    return axios.post("/sale/wx/customer/orderChange", paramsData);
  },
  //定金转换记录
  depositTransferRecord(paramsData) {
    return axios.get(`/sale/wx/customer/orderChangeLog`, {
      params: paramsData
    });
  },
  //订单退款
  orderRefundWX(paramsData) {
    return axios.post("/sale/wx/customer/orderRefund", paramsData);
  },
  //订单审核
  ordercheckWX(paramsData) {
    return axios.post("/sale/wx/customer/ordercheck", paramsData);
  },
  //订单撤回
  orderWithdrawWX(paramsData) {
    return axios.post("/sale/wx/customer/orderWithdraw", paramsData);
  },
  //获取公司所有人员
  getAllSelectStaff(paramsData) {
    return axios.get(`/sale/borrow/selectStaff`, { params: paramsData });
  },
  //获取发票报销类型
  reimbursementTypeListNew(paramsData) {
    return axios.get("/sale/reimbursement/staffReimbursementTypeList", {
      params: paramsData
    });
  },
  //小程序预约带看列表
  visitListSaleList(paramsData) {
    return axios.post("/sale/wx/customer/visitListSale", paramsData);
  },
  //获取小程序带看详情
  visitListSaleDetail(paramsData) {
    return axios.get(`/sale/wx/customer/visitListSaleDetail`, {
      params: paramsData
    });
  },
  //小程序预约带看提交
  visitListSaleFollow(paramsData) {
    return axios.post("/sale/wx/customer/visitListSaleFollow", paramsData);
  },
  //抄送已读
  actReadCc(paramsData) {
    return axios.post("/sale/act/readCc", paramsData);
  },
  //批量送卷
  sendCop(paramsData) {
    return axios.post("/sale/wx/customer/sendCop", paramsData);
  },
  //清除批量送券
  clearSendCop(paramsData) {
    return axios.post("/sale/wx/customer/clearSendCop", paramsData);
  },

  //抄送一键已读
  readAllCc(paramsData) {
    return axios.post("/sale/act/readAllCc", paramsData);
  },
  //取消微信预约带看
  visitListSaleCancel(paramsData) {
    return axios.post("/sale/wx/customer/visitListSaleCancel", paramsData);
  },
  //创建直播间
  createLive(paramsData) {
    return axios.post("/sale/wx/customer/createLive", paramsData);
  },
  //结束直播间
  endLive(paramsData) {
    return axios.post("/sale/wx/customer/endLive", paramsData);
  },
  //获取存量拓展
  selectDeveloper(paramsData) {
    return axios.get(`/sale/pressMoney/selectDeveloper`, {
      params: paramsData
    });
  },
  //直播间列表
  liveList(paramsData) {
    return axios.get(`/sale/wx/customer/liveList`, { params: paramsData });
  },
  //开始直播
  starLive(paramsData) {
    return axios.post("/sale/wx/customer/startLive", paramsData);
  },
  //同步小程序车位 /sale/park/synchronous
  synchronousPark(paramsData) {
    return axios.post("/sale/park/synchronous", paramsData);
  },
  //锁定车位 /sale/wx/customer/parkLockList
  parkLockList(paramsData) {
    return axios.post("/sale/wx/customer/parkLockList", paramsData);
  },
  //锁定详情 /sale/wx/customer/parkLockDetail
  parkLockDetail(paramsData) {
    return axios.get("/sale/wx/customer/parkLockDetail", {
      params: paramsData
    });
  },
  //锁定跟进 /sale/wx/customer/parkLockFollow
  parkLockFollow(paramsData) {
    return axios.post("/sale/wx/customer/parkLockFollow", paramsData);
  },
  //获取免登录北森
  getFreeLoginUrlNew(paramsData) {
    return axios.get("/sale/beiSen/userSso", { params: paramsData });
  },
  //订金列表批量退款
  batchOrderRefund(paramsData) {
    return axios.post("/sale/wx/customer/batchOrderRefund", paramsData);
  },
  //分销列表
  distributionSaleList(paramsData) {
    return axios.get("/sale/wx/customer/list", { params: paramsData });
  },
  //分销详情
  distributionSaleDetail(paramsData) {
    return axios.get("/sale/wx/customer/recommendDetail", {
      params: paramsData
    });
  },
  //根据地区查政策Ai
  listByRegionAi(paramsData) {
    return axios.get(`/sale/project/manage/regionPolicy/ai`, {
      params: paramsData
    });
  },
  //释放长租固定车位
  parkBatchOpen(paramsData) {
    return axios.post("/sale/park/batchOpen", paramsData);
  },
  //订单释放
  customerOrderOpen(paramsData) {
    return axios.post("/sale/wx/customer/orderOpen", paramsData);
  },
  //获取打卡信息
  clockPermissionDetail(paramsData) {
    return axios.get(`/sale/project/manage/clockPermissionDetail`, {
      params: paramsData
    });
  },
  //设置打卡
  setClockPermission(paramsData) {
    return axios.post("/sale/project/manage/setClockPermission", paramsData);
  },
  //修改分销数据
  saveRecommend(paramsData) {
    return axios.post("/sale/wx/customer/saveRecommend", paramsData);
  },
  //获取直播间详情
  getCustomerLiveDetail(paramsData) {
    return axios.get(`/sale/wx/customer/liveDetail`, { params: paramsData });
  },
  //价值地图获取地区
  getProjectMapArea(paramsData) {
    return axios.get(`/sale/projectMap/get`, { params: paramsData });
  },
  //价值地图获取项目
  getProjectMapProject(paramsData) {
    return axios.get(`/sale/projectMap/getProject`, { params: paramsData });
  },
  //车位批量上下架
  parkBatchSetState(paramsData) {
    return axios.post("/sale/park/batchSetState", paramsData);
  },
  //获取用友银行网点数据
  getYonYouBankDotList(paramsData) {
    return axios.get(`/sale/externalCollectionAccount/yonYouBankDotList`, {
      params: paramsData
    });
  },
  //批量分享
  parkShareMore(paramsData) {
    return axios.post("/sale/park/share", paramsData);
  },
  //获取活动业主列表
  getCustomerCopStatList(paramsData) {
    return axios.post(`/sale/wx/customer/customerCopStat`, paramsData);
  },
  //获取分析报告 /sale/customer/analysisReport
  getAnalysisReport(paramsData) {
    return axios.get(`/sale/customer/analysisReport`, { params: paramsData });
  },
  //车位访问次数top5
  getParkVisitTop5(paramsData) {
    return axios.get(`/sale/wx/data/parkTop`, { params: paramsData });
  },
  //车位停留时长top5
  getParkStayTop5(paramsData) {
    return axios.get(`/sale/wx/data/parkStayTop`, { params: paramsData });
  },
  //业主引流来源 /sale/wx/data/userStat
  getUserStat(paramsData) {
    return axios.get(`/sale/wx/data/userStat`, { params: paramsData });
  },
  //业主访问趋势 /sale/wx/data/visitStat
  getVisitStat(paramsData) {
    return axios.get(`/sale/wx/data/visitStat`, { params: paramsData });
  },

  //业主访问时长 /sale/wx/data/visitTimeStat
  getVisitTimeStat(paramsData) {
    return axios.get(`/sale/wx/data/visitTimeStat`, { params: paramsData });
  },
  //人均访问时长 /sale/wx/data/avgVisitTimeStat
  getAvgVisitTimeStat(paramsData) {
    return axios.get(`/sale/wx/data/avgVisitTimeStat`, { params: paramsData });
  },
  //成交金额统计 /sale/wx/data/saleDealPrice
  getSaleDealPrice(paramsData) {
    return axios.get(`/sale/wx/data/saleDealPrice`, { params: paramsData });
  },
  //成交数量统计 /sale/wx/data/saleDeal
  getSaleDeal(paramsData) {
    return axios.get(`/sale/wx/data/saleDeal`, { params: paramsData });
  },
  //定金金额统计 /sale/wx/data/saleOrderPrice
  getSaleOrderPrice(paramsData) {
    return axios.get(`/sale/wx/data/saleOrderPrice`, { params: paramsData });
  },
  //定金数量统计 /sale/wx/data/saleOrder
  getSaleOrder(paramsData) {
    return axios.get(`/sale/wx/data/saleOrder`, { params: paramsData });
  },
  //累计带看统计 /sale/wx/data/saleVisit
  getSaleVisit(paramsData) {
    return axios.get(`/sale/wx/data/saleVisit`, { params: paramsData });
  },
   //OA批量审核
  completeBatchMore(paramsData) {
    return axios.post(`/sale/act/complete/batch`, paramsData);
  },
  //获取活动信息
  customerSendList(paramsData) {
    return axios.get(`/sale/wx/customer/sendList`, { params: paramsData });
  },
  //一键拼团
  marketingManageSet(paramsData) {
    return axios.post(`/sale/wx/customer/setState`, paramsData);
  },
  //获取拼团人员列表
  getMarketingManageList(paramsData) {
    return axios.get(`/sale/wx/customer/groupBuyingDetail`, { params: paramsData });
  },
  //获取拼团活动列表
  getCustomerGroupBuyList(paramsData) {
    return axios.get(`/sale/wx/customer/groupBuyList`, { params: paramsData });
  },
  //开发商接待列表
  getDeveloperReceiveList(paramsData) {
      return axios.get('/sale/developer/receive/list', { params: paramsData });
  },
  //开发商接待详情
  getReceiveDetail(paramsData) {
      return axios.get('/sale/developer/receive/detail', { params: paramsData });
  },
  //开发商接待添加编辑
  saveReceiveDetail(paramsData) {
      return axios.post(`/sale/developer/receive/saveResult`, paramsData);
  },
  //开发商待处理红点
  getReceiveRemind(paramsData) {
      return axios.post(`/sale/developer/receive/remind`, paramsData);
  },
  //开发商待处理红点
  setCustomerUnBind(paramsData) {
      return axios.post(`/sale/wx/customer/unBind`, paramsData);
  },
  //拉卡拉释放订单金额
  saleLklUnLock(paramsData) {
      return axios.post(`/sale/lkl/unLock`, paramsData);
  },
  //获取集团收营信息
  getCmpanyTargetMonth(paramsData) {
      return axios.post(`/sale/target/companyTargetMonth`, paramsData);
  },
  //认证业主详情手机号
  customerPhoneAuth(paramsData) {
      return axios.post(`/sale/customer/phoneAuth`, paramsData);
  },
  //根据经理id获取部门列表
  getSelectBeiSenUserDeptList(paramsData) {
      return axios.get('/sale/beiSen/selectBeiSenUserDeptList', { params: paramsData });
  },
  //发放礼品签到
  customerSignOn(paramsData) {
      return axios.post(`/sale/wx/customer/signOn`, paramsData);
  },
  //带看列表
  getCustomerVisitList(paramsData) {
      return axios.post(`/sale/customerVisit/list`, paramsData);
  },
  //获取团队所有人员
  getProjectTeamInfoAndManager(paramsData) {
      return axios.get('/sale/manager/projectTeamInfoAndManager', { params: paramsData });
  },
  //发起带看
  customerVisitStart(paramsData) {
      return axios.post(`/sale/customerVisit/start`, paramsData);
  },
  //重新生成总结
  customerVisitRestart(paramsData) {
     return axios.post(`/sale/customerVisit/reStart`, paramsData, { timeout: 60000 });
  },
  //带看详情
  customerVisitDetail(paramsData) {
    return axios.get(`/sale/customerVisit/detail`, { params: paramsData });
  },
  //发起带看抽奖
  customerVisitSend(paramsData) {
      return axios.post(`/sale/customerVisit/send`, paramsData);
  },
  //删除带看
  customerVisitDel(paramsData) {
      return axios.post(`/sale/customerVisit/del`, paramsData);
  },
  //结束带看
  customerVisitEnd(paramsData) {
      return axios.post(`/sale/customerVisit/end`, paramsData);
  },
  //带看结束审核
  customerVisitCheckState(paramsData) {
      return axios.post(`/sale/customerVisit/checkState`, paramsData);
  },
  //带看写跟进
  customerVisitFollow(paramsData) {
      return axios.post(`/sale/customerVisit/follow`, paramsData);
  },
  //获取经理陪看数量
  getManagerNum(paramsData) {
    return axios.get(`/sale/project/manage/managerNum`, { params: paramsData });
  },
  //获取活动列表
  getEventLibList(paramsData) {
      return axios.post(`/sale/eventLib/list`, paramsData);
  },
  //设置收款账号启用
  externalCollectionAccountSaveStatus(paramsData) {
      return axios.post(`/sale/externalCollectionAccount/saveStatus`, paramsData);
  },
  //获取投票活动列表
  getVoteActivityList(paramsData) {
      return axios.get(`/sale/wx/customer/groupVoteList`, { params: paramsData });
  },
  //获取投票活动详情列表
  getVoteActivityDetail(paramsData) {
      return axios.get(`/sale/wx/customer/groupVoteDetailList`, { params: paramsData });
  },
  //新增投票对象
  addVoteObject(paramsData) {
      return axios.post(`/sale/wx/customer/saveVote`, paramsData);
  },
  //加票
  addVoteNum(paramsData) {
      return axios.post(`/sale/wx/customer/addVote`, paramsData);
  },
  //获取线下带看待审核数量
  getCustomerVisitCheckNum(paramsData) {
    return axios.get(`/sale/customerVisit/checkNum`, { params: paramsData });
  },
 //投票上下架
  upDownVoteActivity(paramsData) {
    return axios.post(`/sale/wx/customer/upDown`, paramsData);
  },
  //获取员工ID、姓名列表
  getStaffIdAndName(paramsData) {
    return axios.get(`/sale/integralReporting/getStaffIdAndName`, { params: paramsData });
  },
  //查看是否已超签约总金额
  gtSignMoney(paramsData) {
    return axios.get(`/sale/buy/gtSignMoney`, { params: paramsData });
  },
  //开启不用pos机权限
  customerUpdatePos(paramsData) {
    return axios.post(`/sale/customer/updatePos`, paramsData);
  },
   //获取AI对话列表
    getExpandChatHistoryList(paramsData) {
        return axios.get(base.aiPostUrl+'chat/api/sale/chat/historyList', { params: paramsData });
    },
    //获取AI对话详情
    getExpandChatHistoryDetail(paramsData) {
        return axios.get(base.aiPostUrl+'chat/api/sale/chat/history', { params: paramsData });
    },
    //获取微信用户信息
    getWxUserInfo(paramsData) {
        return axios.get('/sale/project/manage/wxInfo', { params: paramsData });
    },
    //获取产值地图项目
    getWorkbenchValueMap(paramsData) {
        return axios.get('/sale/workbench/valueMap', { params: paramsData });
    },
    //获取平均服务费
    getAVGServiceFee(paramsData) {
        return axios.get('/sale/buy/avgServiceFee', { params: paramsData });
    },
    //演员打卡列表
    getActorClockInData(paramsData) { //sale/actorsClockIn/sale/list
        return axios.get(`/sale/actorsClockIn/sale/list`, { params: paramsData });
    },
    //选择经理的项目场次
    getManagerProjectData(paramsData) {
        return axios.get('/sale/actorsClockIn/selectManagerProject', { params: paramsData });
    },
    //保存演员打卡
    saveActorClockIn(paramsData) {
        return axios.post(`/sale/actorsClockIn/save`, paramsData);
    },
    //获取演员打卡详情
    getActorClockInDetail(paramsData) {
        return axios.get(`/sale/actorsClockIn/detail`, { params: paramsData });
    },
    //演员打卡审核
    checkActorClockIn(paramsData) {
        return axios.post(`/sale/actorsClockIn/check`, paramsData);
    },
    //获取演员打卡审核信息
    getActorClockInCheckInfo(paramsData) { //sale/actorsClockIn/checkInfo
        return axios.get(`/sale/actorsClockIn/checkInfo`, { params: paramsData });
    },
    //经理签字确认
    confirmActorClockInSign(paramsData) {
        return axios.post(`/sale/actorsClockIn/sure`, paramsData);
    },
    //项目场次演员打卡信息
    getPprojectActorsClockInInfo(paramsData) {
        return axios.get('/sale/reimbursement/projectActorsClockInInfo', { params: paramsData });
    },
    getCustomerWXData(paramsData) {
        return axios.get('/sale/wx/data/wxStats', { params: paramsData });
    },
    getActivityWxData(paramsData) {
        return axios.get('/sale/wx/data/wxActStats', { params: paramsData });
    },
    //重合感兴趣 /sale/wx/data/mergeData
    getMergeData(paramsData) {
      return axios.get('/sale/wx/data/mergeData', { params: paramsData });
    },
    //去重兴趣点 /sale/wx/data/noMergeData
    getNoMergeData(paramsData) {
      return axios.get('/sale/wx/data/noMergeData', { params: paramsData });
    },
    //系统兴趣点 /sale/wx/data/systemData
    getSysData(paramsData) {
      return axios.get('/sale/wx/data/systemData', { params: paramsData });
    },
    //小程序兴趣点 /sale/wx/data/miniData
    getMiniData(paramsData) {
      return axios.get('/sale/wx/data/miniData', { params: paramsData });
    },
    // 楼栋分析 /sale/wx/data/wxBuildDataStat
    getWxBuildDataStat(paramsData) {
        return axios.get('/sale/wx/data/wxBuildDataStat', { params: paramsData });
    },
    //长租业主分析 /sale/wx/data/wxRentDataStat
    getWxRentDataStat(paramsData) {
        return axios.get('/sale/wx/data/wxRentDataStat', { params: paramsData });
    },
    //设置为已读 /sale/actorsClockIn/setAsRead
    setAsRead(paramsData) {
        return axios.post(`/sale/actorsClockIn/setAsRead`, paramsData);
    },
    //未读数量 /sale/actorsClockIn/unReadCount
    getUnReadCount(paramsData) {
        return axios.get(`/sale/actorsClockIn/unReadCount`, { params: paramsData });
    },
    //线下活动数据 /sale/wx/data/wxOnlineDataStat
    getWxOnlineDataStat(paramsData) {
        return axios.get('/sale/wx/data/wxOnlineDataStat', { params: paramsData });
    },
    //线上直播数据 /sale/wx/data/wxLiveDataStat
    getWxLiveDataStat(paramsData){
        return axios.get('/sale/wx/data/wxLiveDataStat', { params: paramsData });
    },
    //车位关联电子收据
    getReceiptList(paramsData) {
        return axios.get(`/sale/buy/receiptList`, { params: paramsData });
    },
    //分页查询调动通知列表
    projectTransferList(paramsData) {
        return axios.post(`/sale/projectTransfer/pageList`, paramsData);
    },
    //新增调动通知
    projectTransferSubmit(paramsData) {
        return axios.post(`/sale/projectTransfer/add`, paramsData);
    },
    //获取项目调动通知单详情
    getProjectTransferNoticeDetail(paramsData) {
        return axios.get(`/sale/projectTransfer/detail`, { params: paramsData });
    },
    //新增调动通知
    projectTransferDelet(paramsData) {
        return axios.post(`/sale/projectTransfer/delete?id=${paramsData.id}`, paramsData);
    },
    //标记调动通知为已知晓
    projectTransferMarkAsRead(paramsData) {
        return axios.post(`/sale/projectTransfer/markAsRead?id=${paramsData.id}`, paramsData);
    },
    //租赁记录
    getParkingRentalData(paramsData){ // /sale/wx/customer/rentList
        return axios.post(`/sale/wx/customer/rentList`, paramsData);
    },
    //下架车位
    updateParkingStatus(paramsData) {
       return axios.post(`/sale/wx/customer/rentUpDown`, paramsData);
    },
    //查询直播弹幕
    getLiveDanMuList(liveId, type) {
        return axios.get(`/sale/wx/customer/liveDanmaku?liveId=${liveId}&type=${type}`);
    },
    //修改弹幕
    updateLiveDanMu(paramsData) {
        return axios.post(`/sale/wx/customer/updateLiveDanmaku`, paramsData);
    },
    //电子收据列表
    getReceiptListNo(paramsData) {
        return axios.post(`/sale/receipt/list`, paramsData);
    },
    //新增电子收据
    addReceipt(paramsData) {
        return axios.post(`/sale/receipt/save`, paramsData);
    },
    //红冲电子收据
    redReversalReceipt(paramsData) {
        return axios.post(`/sale/receipt/setStatus`, paramsData);
    },
    //ai通用get请求
    getDataForAi(paramsData) {
      let url = paramsData.httpUrl;
      delete paramsData.httpUrl;
      return axios.get(url, { params: paramsData });
    },
    //智能体应用列表
    getAIAgentList(paramsData) {
        return axios.post(`/sale/aiAgent/aiAgentList`, paramsData);
    },
    //sale/merchantOrderAd/add 经理发起广告申请
    addMerchantOrderAd(paramsData) {
      return axios.post(`/sale/merchantOrderAd/add`, paramsData);
    },
    //sale/merchantOrderAd/update 经理更新广告申请
    updateMerchantOrderAd(paramsData) {
      return axios.post(`/sale/merchantOrderAd/update`, paramsData);
    },
    //分页查询广告订单列表 /sale/merchantOrderAd/pageList
    getMerchantOrderAdList(paramsData) {
      return axios.post(`/sale/merchantOrderAd/pageList`, paramsData);
    },
    //查看广告订单详情 /sale/merchantOrderAd/detail
    getMerchantOrderAdDetail(paramsData) {
      return axios.get(`/sale/merchantOrderAd/detail`, { params: paramsData });
    },
    //广告申请审核通过 /sale/merchantOrderAd/approve
    approveMerchantOrderAd(paramsData) {
      return axios.post(`/sale/merchantOrderAd/approve`, paramsData);
    },
   // 广告订单审核  /sale/merchantOrderAd/reject
    refuseMerchantOrderAd(paramsData) {
      return axios.post(`/sale/merchantOrderAd/reject`, paramsData);
    },
    // 智能体调用保存
    saveMerchantOrderAd(paramsData) {
      return axios.post(`/sale/aiAgent/saveNum`, paramsData);
    },
    // Ai面谈录音列表
    getInterviewRecordList(paramsData) {
      return axios.post(`/sale/aiInterviewRecord/interviewRecordList`,paramsData)
    },
    // Ai面谈录音详情  /sale/aiInterviewRecord/detail
    getInterviewDetail(paramsData) {
      return axios.get(`/sale/aiInterviewRecord/detail`, { params: paramsData });
    },
    // Ai面谈录音保存  /sale/aiInterviewRecord/save
    saveInterviewRecord(paramsData) {
      return axios.post(`/sale/aiInterviewRecord/save`, paramsData);
    },
    // Ai面谈录音删除  /sale/aiInterviewRecord/delete
    deleteInterviewRecord(paramsData) {
      return axios.get(`/sale/aiInterviewRecord/delete`, { params: paramsData });
    },
  // 获取车架号
  getCarFrameNum(paramsData) {
    return axios.get(`/sale/park/getVin`, { params: paramsData });
  },
  // 获取用户签名
  getImSignApi(id) {
    return axios.get(`/sale/wx/customer/genTestUserSig`, { params: { uid: id } });
  },
  // 反馈讨论列表
  getFeedbackDiscussList(paramsData) {
    return axios.get(`/sale/feedback/groupList`, { params: paramsData });
  },
  // 挪车管理列表 sale/moveCar/list
  getMoveCarList(paramsData) {
    return axios.post(`/sale/moveCar/list`, paramsData);
  },
  //添加挪车车辆
  addMoveCar(paramsData){
    return axios.post(`/sale/moveCar/add`, paramsData);
  },
  //挪车详情 /sale/moveCar/detail
  getMoveCarDetail(paramsData){
    return axios.get(`/sale/moveCar/detail`, { params: paramsData });
  },
  //是否有签章
  getSignature(paramsData) {
    return axios.get(`/sale/receipt/hasSign`, { params: paramsData });
  },
  //删除项目踩盘
  deleteProjectFootprint(paramsData) {
    return axios.post(`/sale/project/firstInfo/del`, paramsData);
  },
  //自主培训课堂选择该公司下所有人员 /sale/offline/allPerson
  getAllPerson(paramsData) {
    return axios.get(`/sale/offline/allPerson`, { params: paramsData });
  },
  //自主培训选择试题 /sale/scoring/get
   getScoringList(paramsData) {
    return axios.get(`/sale/scoring/get`, { params: paramsData });
   },
  // 查询物流信息
  searchLogicsInfo(paramsData) {
    return axios.post(`/sale/logistics/search`, paramsData);
  },
};

export default apis;



// WEBPACK FOOTER //
// ./src/request/apis.js